"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56956,42609],{

/***/ 289924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);



const CustomLink = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].a(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLink, {
    href: link,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;




/***/ }),

/***/ 955006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(289924);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203494);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ isMobile, theme }) => `
  display: flex;
  padding: ${theme == null ? void 0 : theme.spacing.s16} 0;
  align-items: ${!isMobile ? "flex-end" : "center"};
  column-gap: ${theme == null ? void 0 : theme.spacing.s4};
  white-space: nowrap;
  overflow: hidden;
  ${!isMobile ? `.breadcrumb-item:last-child div {
            white-space: normal
        }` : `
        overflow-x: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      `}
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`);
const Breadcrumbs = (_a) => {
  var _b = _a, {
    breadcrumbs = [],
    isMobile
  } = _b, rest = __objRest(_b, [
    "breadcrumbs",
    "isMobile"
  ]);
  if (!breadcrumbs.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    isMobile
  }), breadcrumbs.map((item, index) => {
    const isLast = index === breadcrumbs.length - 1 || item.isLast;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      key: index
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_BreadcrumbItem_es_js__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbItem */ .g, __spreadValues({
      key: index
    }, item)), !isLast && !!item.name && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RightOutlined */ .g, {
      color: "placeholder",
      size: 16,
      style: { textAlign: "right", overflow: "visible" }
    }));
  }));
};




/***/ }),

/***/ 635412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82389);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(281668);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .getArrowClassName */ .C)(attributes) || ""
  }), menu));
};
const DropdownMenu = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const StyledArrow = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;




/***/ }),

/***/ 816519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(593859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false,
    trackingArrowRight,
    trackingArrowLeft,
    customStyleLeftArrow,
    customStyleRightArrow,
    displayNewLayout
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet",
    "trackingArrowRight",
    "trackingArrowLeft",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "displayNewLayout"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, [children.length]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style,
    displayNewLayout
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView} - 8px) `
      }
    }, child);
  }))), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`,
    style: customStyleLeftArrow
  }, trackingArrowLeft)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`,
    style: customStyleRightArrow
  }, trackingArrowRight))), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  }))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => `
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  ${props.displayNewLayout ? `.glide__arrow--override {
    visibility: visible;
    width: 28px;
    height: 28px;
  }
  .horizontal-slider,
  .glide__track {
    margin: 0 auto;
    background-color: white;
  }
  .glide__slides {
    margin: 0 auto;
  }
  .glide__arrow--left {
    left: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .glide__arrow--right {
    right: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }` : ``}
`);
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 209705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Textarea = (_a) => {
  var _b = _a, {
    title,
    value,
    rows = 4,
    placeholder,
    error,
    disabled,
    readonly,
    maxLength,
    autoFocus,
    defaultValue,
    onChange,
    onFocus,
    onBlur,
    onKeyDown
  } = _b, rest = __objRest(_b, [
    "title",
    "value",
    "rows",
    "placeholder",
    "error",
    "disabled",
    "readonly",
    "maxLength",
    "autoFocus",
    "defaultValue",
    "onChange",
    "onFocus",
    "onBlur",
    "onKeyDown"
  ]);
  const [isFocus, setIsFocus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleFocus = (e) => {
    !(readonly || disabled) && setIsFocus(true);
    !!onFocus && onFocus(e);
  };
  const handleBlur = (e) => {
    !(readonly || disabled) && setIsFocus(false);
    !!onBlur && onBlur(e);
  };
  const colorState = disabled ? "disable" : error ? "error500" : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTextareaWrapper, __spreadValues({}, rest), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 2,
    color: "textPrimary",
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTextarea, {
    value,
    rows,
    placeholder,
    onChange: (event) => onChange && onChange(event.target.value),
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: (event) => {
      if (onKeyDown)
        onKeyDown(event);
    },
    readOnly: readonly,
    disabled,
    maxLength,
    autoFocus,
    defaultValue,
    isFocus,
    colorState
  }));
};
const StyledTextareaWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
`;
const StyledTextarea = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].textarea`
  resize: vertical;
  width: 100%;
  border: ${(p) => `1px solid ${p.isFocus ? p.theme.colors.link500 : p.theme.colors[p.colorState] || p.theme.colors.divider}`};
  border-radius: ${(p) => p.theme.borderRadius.s};
  padding: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.disabled ? p.theme.colors.background : p.theme.colors.white};
  font-size: 13px;
  color: ${(p) => p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};
  &::placeholder {
    color: ${(p) => p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
  }
  &:focus {
    outline: none;
  }
`;




/***/ }),

/***/ 651337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const ModalFooter = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 640793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TabItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBody = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT)`
  &:hover {
    color: ${(p) => p.activeColor};
  }
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: ${(p) => `${p.theme.spacing.s8} ${p.theme.spacing.s16}`};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${(props) => props.minWidth ? props.minWidth : ""};
  max-width: ${(props) => props.maxWidth ? props.maxWidth : ""};
  background-color: ${(props) => props.isActive ? props.activeBackground : props.background};
  ${(p) => p.fluid ? `
    flex: 1;
  ` : ``}
  flex-direction: ${(p) => p.direction === "horizontal" ? "row" : "column"};
  ${(p) => !p.ignoreSecondChildStyles && `
      > *:nth-child(2) {
        ${p.direction === "horizontal" ? `
          flex: 1;
          margin-left: ${p.theme.spacing.s8};
        ` : `
          line-height: 1.5rem;
          margin-top: ${p.theme.spacing.s4};
        `}
      }
    `}
  &:hover {
    ${(props) => props.type === "line" ? `
      path[stroke],
      rect[stroke],
      line {
        stroke: ${props.theme.colors.primary500};
      }` : ""};
    path:not([stroke]),
    rect:not([stroke]) {
      fill: ${(p) => p.theme.colors.primary500};
    }
    > .tab-title {
      color: ${(p) => p.theme.colors.primary500};
    }
  }
`;
const TabItem = (_a) => {
  var _b = _a, {
    tabId,
    text,
    minWidth,
    maxWidth,
    icon,
    color = "textSecondary",
    activeColor = "primary500",
    background = "white",
    activeBackground = "white",
    direction = "horizontal",
    type,
    className,
    onClick,
    tabTitle
  } = _b, rest = __objRest(_b, [
    "tabId",
    "text",
    "minWidth",
    "maxWidth",
    "icon",
    "color",
    "activeColor",
    "background",
    "activeBackground",
    "direction",
    "type",
    "className",
    "onClick",
    "tabTitle"
  ]);
  const { activeTab, fluid, dispatch, onChange } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const isActive = tabId === activeTab;
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (elementRef.current && isActive) {
      onChange(tabId);
      dispatch({
        type: "setDimension",
        payload: {
          dimension: {
            width: elementRef.current.offsetWidth,
            left: elementRef.current.offsetLeft,
            height: elementRef.current.offsetHeight,
            top: elementRef.current.offsetTop
          }
        }
      });
    }
  }, [activeTab, dispatch]);
  const handleClick = () => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
    onClick == null ? void 0 : onClick();
    if (elementRef.current)
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center"
      });
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    isActive,
    background,
    activeBackground,
    color,
    activeColor,
    ref: elementRef,
    onClick: handleClick,
    direction,
    fluid,
    type,
    className,
    minWidth,
    maxWidth,
    ignoreSecondChildStyles: !!tabTitle
  }, rest), icon ? react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
    color: isActive ? activeColor : color
  }) : null, text ? isActive ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 4,
    color: activeColor,
    line: 1
  }, text) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBody, {
    level: 1,
    color,
    line: 1,
    activeColor
  }, text) : null, tabTitle && react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(tabTitle, {
    color: isActive ? activeColor : color
  }));
};




/***/ }),

/***/ 517844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(846291);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19840);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  position: relative;
  height: 100%;
`;
const TabTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ width, left, theme, type }) => `
    position: relative;
    display: flex;
    align-items: stretch;
    overflow-x: scroll;
    overflow-y: hidden;
    width: 100%;
    ${type === "line" ? `border-bottom: 1px solid ${theme == null ? void 0 : theme.colors.divider};&::after {
      content: ' ';
      height: 2px;
      background-color: ${theme == null ? void 0 : theme.colors.primary500};
      display: inline-block;
      position: absolute;
      transition: all 0.2s ease-out;
      bottom: 0;
      left: ${left}px;
      width: ${width}px;
    }` : ""}
    /* Hide scroll bar */
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }


  `);
const Component = (_a) => {
  var _b = _a, {
    children,
    textActiveColor,
    textColor,
    background,
    activeBackground,
    type = "line",
    tabTitleProps
  } = _b, rest = __objRest(_b, [
    "children",
    "textActiveColor",
    "textColor",
    "background",
    "activeBackground",
    "type",
    "tabTitleProps"
  ]);
  var _a2, _b2;
  const {
    dimension: { width, left, top, height },
    activeTab
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsContext */ .RL);
  const arr = children.filter(_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .isNotNullOrUndefinedElement */ .C4);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabTitle, __spreadProps(__spreadValues({}, tabTitleProps), {
    type,
    width,
    left,
    top,
    height
  }), arr.map((item, index) => react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(item, {
    key: index,
    tabId: index,
    color: textColor,
    activeColor: textActiveColor,
    background,
    activeBackground,
    type
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (_b2 = (_a2 = arr[activeTab]) == null ? void 0 : _a2.props) == null ? void 0 : _b2.children));
};
const withContext = (Component2) => {
  const Comp = (_a) => {
    var _b = _a, {
      fluid = false,
      children,
      defaultTab = 0,
      activeTab = defaultTab
    } = _b, rest = __objRest(_b, [
      "fluid",
      "children",
      "defaultTab",
      "activeTab"
    ]);
    const tabState = (0,_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useTabs */ .YE)(activeTab, fluid);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TabsContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TabsProvider */ .X, __spreadValues({}, tabState), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, __spreadValues({}, rest), children));
  };
  return Comp;
};
const Tabs = withContext(Component);




/***/ }),

/***/ 846291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ TabsContext; },
/* harmony export */   "X": function() { return /* binding */ TabsProvider; },
/* harmony export */   "YE": function() { return /* binding */ useTabs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultValue = {
  activeTab: 0,
  fluid: false,
  dimension: {
    left: 0,
    width: 0,
    top: 0,
    height: 0
  },
  dispatch: (_) => {
  },
  onChange: (_) => {
  }
};
const reducer = (state, action) => {
  var _a, _b;
  switch (action.type) {
    case "changeTab":
      return __spreadProps(__spreadValues({}, state), {
        activeTab: (_a = action.payload.activeTab) != null ? _a : state.activeTab
      });
    case "setDimension":
      return __spreadProps(__spreadValues({}, state), {
        dimension: (_b = action.payload.dimension) != null ? _b : state.dimension
      });
    default:
      return state;
  }
};
const useTabs = (defaultTab, fluid) => {
  const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, __spreadProps(__spreadValues({}, defaultValue), {
    fluid,
    activeTab: defaultTab
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    onChangeTab(defaultTab);
  }, [defaultTab]);
  const onChangeTab = (tabId) => {
    dispatch({ type: "changeTab", payload: { activeTab: tabId } });
  };
  return __spreadProps(__spreadValues({}, state), { onChange: onChangeTab, dispatch });
};
const TabsContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultValue);
const TabsProvider = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TabsContext.Provider, {
    value: __spreadValues({}, props)
  }, children);
};




/***/ }),

/***/ 517293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ChevronForwardFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronForwardFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      { tag: "title", attr: {}, child: [] },
      {
        tag: "polyline",
        attr: {
          points: "184 112 328 256 184 400",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "currentColor"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 551838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ChevronUpFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ChevronUpFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 512 512", fill: "none" },
    child: [
      {
        tag: "polyline",
        attr: {
          points: "112 328 256 184 400 328",
          strokeWidth: "48px",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#000"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 767535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ FireFlashsaleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FireFlashsaleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M11.8903 0.644C10.0379 1.936 8.46667 3.909 7.58667 6.007C6.99487 5.972 6.4 6.085 5.85128 6.349C3.84308 7.297 2.12923 9.737 2.00923 13.781C2.00205 13.871 2 14.01 2 14.249C2 19.628 6.48308 23.999 12 23.999C17.5292 23.984 22 19.621 22 14.249C22 14.108 21.9928 13.956 21.9815 13.755C21.9774 13.695 21.9774 13.695 21.9744 13.637C21.9662 13.509 21.9579 13.394 21.9518 13.309C21.7426 10.656 20.8462 8.735 19.1744 6.488C19.0472 6.316 18.9477 6.185 18.7292 5.898C18.3662 5.422 18.2174 5.223 18.0554 4.991C17.5467 4.264 17.3846 3.856 17.3846 3.376C17.3846 2.111 16.6595 0.955 15.5097 0.376C15.0103 0.124 14.4667 0 13.9231 0C13.2072 0 12.4944 0.216 11.8903 0.644Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.6997 3.07C12.0013 4.256 10.5848 6.253 10.0884 8.158C9.74484 9.485 9.69971 10.976 9.69356 11.962C8.12433 11.635 7.76946 9.347 7.76535 9.323C7.74792 9.204 7.67407 9.1 7.56535 9.044C7.45561 8.988 7.3274 8.984 7.21664 9.037C7.13458 9.076 5.19817 10.036 5.08535 13.867C5.07715 13.995 5.07715 14.122 5.07715 14.249C5.07715 17.971 8.18279 20.999 12.0002 20.999C15.8279 20.989 18.9233 17.965 18.9233 14.249C18.9233 14.062 18.8833 13.538 18.8833 13.538C18.672 10.854 17.39 9.172 16.2597 7.688C15.2125 6.313 14.3079 5.126 14.3079 3.376C14.3079 3.235 14.2269 3.106 14.0997 3.042C14.0433 3.014 13.9828 3 13.9223 3C13.8433 3 13.7654 3.024 13.6997 3.07Z",
          fill: "#F4811F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.6372 13.206C11.4454 13.985 11.4311 14.847 11.4311 15.595C11.4311 15.885 11.19 16.12 10.8916 16.12C9.98492 16.12 9.42594 15.518 9.11415 14.864C8.94697 15.219 8.79517 15.751 8.77363 16.532C8.76953 16.609 8.76953 16.673 8.76953 16.736C8.76953 18.587 10.2188 20.091 12.0003 20.091C13.7818 20.091 15.2311 18.587 15.2311 16.736C15.2311 16.638 15.2239 16.548 15.2177 16.458C15.1049 14.936 14.4608 14.043 13.8372 13.18C13.4013 12.576 12.9562 11.958 12.7265 11.194C12.2126 11.783 11.8065 12.517 11.6372 13.206Z",
          fill: "#FFD753"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 576862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FlashSaleFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FlashSaleFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM9.27655 5.41169C9.37245 4.86779 9.89111 4.50462 10.435 4.60053L16.5319 5.67558C16.898 5.74012 17.0681 6.16732 16.8467 6.46585L13.3551 11.1733C13.2222 11.3524 13.3243 11.6087 13.544 11.6475L15.36 11.9677C15.74 12.0347 15.9041 12.4887 15.6548 12.7832L9.75245 19.7537C9.55456 19.9874 9.17488 19.8093 9.22806 19.5077L10.1988 14.0023C10.2468 13.7304 10.0652 13.4711 9.79323 13.4231L8.9069 13.2668C8.363 13.1709 7.99984 12.6523 8.09574 12.1084L9.27655 5.41169Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 418536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PlayOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PlayOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12V12Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.9411 9.05794L14.8231 11.3539C14.9352 11.4203 15.0282 11.5147 15.0927 11.6279C15.1573 11.7411 15.1912 11.8691 15.1912 11.9994C15.1912 12.1297 15.1573 12.2578 15.0927 12.371C15.0282 12.4842 14.9352 12.5786 14.8231 12.6449L10.9411 14.9409C10.8272 15.0084 10.6974 15.0444 10.565 15.0455C10.4326 15.0465 10.3023 15.0125 10.1873 14.9469C10.0724 14.8813 9.9768 14.7864 9.91036 14.6719C9.84393 14.5574 9.80898 14.4273 9.80908 14.2949V9.70394C9.80898 9.57155 9.84393 9.4415 9.91036 9.32699C9.9768 9.21248 10.0724 9.11759 10.1873 9.05197C10.3023 8.98636 10.4326 8.95234 10.565 8.95339C10.6974 8.95444 10.8272 8.99051 10.9411 9.05794Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 203494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RightOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RightOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8.49976 19.0001L15.4998 12.0001L8.49976 5.00012",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 893555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ UserProfileColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UserProfileColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15571_332)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M10 9.99994C10.9889 9.99994 11.9556 9.7067 12.7779 9.15729C13.6001 8.60788 14.241 7.82699 14.6194 6.91336C14.9978 5.99973 15.0969 4.99439 14.9039 4.02449C14.711 3.05458 14.2348 2.16367 13.5355 1.46441C12.8363 0.765145 11.9454 0.288941 10.9755 0.0960148C10.0055 -0.0969113 9.00021 0.00210539 8.08658 0.380544C7.17295 0.758982 6.39206 1.39984 5.84265 2.22209C5.29324 3.04434 5 4.01103 5 4.99994C5.00132 6.32562 5.52853 7.59662 6.46593 8.53401C7.40332 9.47141 8.67432 9.99862 10 9.99994ZM10 1.66661C10.6593 1.66661 11.3037 1.8621 11.8519 2.22838C12.4001 2.59465 12.8273 3.11524 13.0796 3.72433C13.3319 4.33342 13.3979 5.00364 13.2693 5.65024C13.1407 6.29685 12.8232 6.89079 12.357 7.35696C11.8908 7.82314 11.2969 8.14061 10.6503 8.26923C10.0037 8.39784 9.33348 8.33183 8.72439 8.07954C8.1153 7.82725 7.59471 7.40001 7.22844 6.85184C6.86216 6.30368 6.66667 5.65921 6.66667 4.99994C6.66667 4.11589 7.01786 3.26804 7.64298 2.64292C8.2681 2.0178 9.11595 1.66661 10 1.66661Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10 11.6672C8.01155 11.6694 6.10518 12.4603 4.69914 13.8663C3.29309 15.2724 2.50221 17.1787 2.5 19.1672C2.5 19.3882 2.5878 19.6002 2.74408 19.7564C2.90036 19.9127 3.11232 20.0005 3.33333 20.0005C3.55435 20.0005 3.76631 19.9127 3.92259 19.7564C4.07887 19.6002 4.16667 19.3882 4.16667 19.1672C4.16667 17.6201 4.78125 16.1363 5.87521 15.0424C6.96917 13.9484 8.4529 13.3338 10 13.3338C11.5471 13.3338 13.0308 13.9484 14.1248 15.0424C15.2188 16.1363 15.8333 17.6201 15.8333 19.1672C15.8333 19.3882 15.9211 19.6002 16.0774 19.7564C16.2337 19.9127 16.4457 20.0005 16.6667 20.0005C16.8877 20.0005 17.0996 19.9127 17.2559 19.7564C17.4122 19.6002 17.5 19.3882 17.5 19.1672C17.4978 17.1787 16.7069 15.2724 15.3009 13.8663C13.8948 12.4603 11.9884 11.6694 10 11.6672Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15571_332" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 781662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ButtonChevron; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(551838);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTransform = (props) => {
  let style = "";
  switch (props.direction) {
    case "right":
      style = "transform: rotate(90deg)";
      break;
    case "down":
      style = "transform: rotate(180deg)";
      break;
    case "left":
      style = "transform: rotate(-90deg)";
      break;
  }
  return style;
};
const StyledIcon = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .ChevronUpFilled */ .p)((props) => `
  transition: transform .2s ease-in-out;
  ${getTransform(props)};
  position: relative;
  margin-left: 2px;
`);
const StyledButton = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z)`
  display: flex;
`;
const ButtonChevron = (_a) => {
  var _b = _a, {
    children,
    direction,
    showArrow = true
  } = _b, props = __objRest(_b, [
    "children",
    "direction",
    "showArrow"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    weight: "regular",
    line: 1
  }, children), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    direction,
    size: 12
  }));
};




/***/ }),

/***/ 174925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BottomActionBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledBottomActionBar = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(`
  padding-bottom: env(safe-area-inset-bottom);
  min-height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  border-top: 1px solid #ddd;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  z-index: 1030;
  display: flex;
  align-items: center;
  justify-content: space-between;
  `, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const BottomActionBar = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottomActionBar, __spreadValues({}, props), children);
};




/***/ }),

/***/ 842918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ BlockHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(917709);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const RightOutlined = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(88677), __webpack_require__.e(80710)]).then(__webpack_require__.bind(__webpack_require__, 588677)).then((mod) => mod.RightOutlined));
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  isMobile,
  theme,
  backgroundColor
}) => `
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${!isMobile ? `
          padding-left: ${theme.spacing.s16};
          padding-right: ${theme.spacing.s16};
          ` : ""}
  height: ${isMobile ? "2.75rem" : "3.5rem"};
  background-color: ${backgroundColor};
`);
const SeeAll = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, color }) => `
    cursor: pointer;
    color: ${theme.colors[color] || theme.colors.textSecondary};
`);
const BlockHeader = ({
  title,
  titleColor,
  link,
  backgroundColor = "unset",
  tracking,
  className,
  style
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .useDevice */ .F)();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className,
    isMobile,
    backgroundColor,
    style
  }, link ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, __spreadValues({}, link), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SeeAll, __spreadValues({
    color: link.color || ""
  }, tracking), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_6__.t)("Xem t\u1EA5t c\u1EA3"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightOutlined, {
    color: link.color
  })))) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, {
    color: titleColor || "textTitle",
    className: "title"
  }, title));
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 784241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a;
  return `
    width: ${100 / ((_a = props.slidesPerView) != null ? _a : 1)}%;
    flex-shrink: 0;
    margin-right: 8px;
  `;
});




/***/ }),

/***/ 414562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77322);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(784241);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(922859);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border,
    customStyleLeftArrow,
    customStyleRightArrow,
    desktopProps
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "desktopProps"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const trackViewProductListData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (trackViewProductListData.length > 0) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackViewProductList */ .u)(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        regionName,
        isTrackContent: true,
        contentName: product.sku,
        target: "productDetail",
        index: index + 1,
        payload: product.bestComboDiscount && Number(product.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, __spreadValues(__spreadProps(__spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className,
    customStyleLeftArrow,
    customStyleRightArrow
  }, props), {
    showControl: products.length > (productsPerRow || 5),
    swipeThreshold: products.length > (productsPerRow || 5),
    dragThreshold: products.length > (productsPerRow || 5)
  }), desktopProps), products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
      regionName,
      isTrackContent: true,
      contentName: item.sku,
      target: "productDetail",
      index: index + 1,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__["default"])(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));




/***/ }),

/***/ 309396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ProductCarouselWithHeader; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(990241);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414562);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(842918);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarouselWithHeader = (_a) => {
  var _b = _a, {
    header,
    background,
    dividerColor = "rgba(255, 255, 255, 0.5)",
    style,
    tracking,
    backgroundStyle
  } = _b, productCarouselProps = __objRest(_b, [
    "header",
    "background",
    "dividerColor",
    "style",
    "tracking",
    "backgroundStyle"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const MOBILE_BG_WIDTH = 856, DESKTOP_BG_WIDTH = 1232;
  const backgroundUrl = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .getImageUrlFromGoogleUserContent */ .Nc)(background, {
    width: isMobile ? MOBILE_BG_WIDTH : DESKTOP_BG_WIDTH
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    style: __spreadValues({
      minHeight: header ? "416px" : "372px"
    }, style)
  }, !!tracking ? tracking : {}), backgroundUrl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Background, {
    alt: (header == null ? void 0 : header.title) || "",
    src: backgroundUrl,
    width: "100%",
    height: "100%",
    style: backgroundStyle
  }), header && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBlockHeader, __spreadProps(__spreadValues({}, header), {
    borderColor: dividerColor
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledProductCarousel, __spreadValues({}, productCarouselProps)));
};
ProductCarouselWithHeader.displayName = "ProductCarouselWithHeader";
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: relative;
`;
const Background = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].img`
  position: absolute;
  top: 0;
`;
const StyledProductCarousel = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductCarousel_ProductCarousel_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCarousel */ .G)`
  padding: 12px;
`;
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_BlockHeader_BlockHeader_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BlockHeader */ .t)`
  border-bottom: 1px solid ${(props) => props.borderColor};
  .title {
    padding: 0 8px;
  }
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(456933);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 110413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LazyComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



function LazyComponent(param) {
    let { children , timeToRender =0  } = param;
    const ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    const { isBot  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const { 0: hydrated , 1: setHydrated  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isBot ? true : false);
    react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect(()=>{
        if (isBot || !ref.current) return;
        const ob = new IntersectionObserver((entries, observer)=>{
            for (const entry of entries){
                if (entry.isIntersecting) {
                    setHydrated(true);
                    observer.disconnect();
                    return;
                }
            }
        });
        ob.observe(ref.current);
        function hydrate(deadline) {
            if (deadline.timeRemaining() > timeToRender) {
                setHydrated(true);
                ob.disconnect();
            } else {
                requestIdleCallback(hydrate);
            }
        }
        if (timeToRender > 0) {
            requestIdleCallback(hydrate);
        }
        return ()=>ob.disconnect();
    }, [
        isBot,
        timeToRender
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: "lazy-component",
        children: hydrated ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fake-body",
            style: {
                width: "100%",
                height: 200
            }
        })
    });
}


/***/ }),

/***/ 514605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



const StyledBar = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { barHeight , barBorder , theme , backgroundColor , justify  } = param;
    return "\n  height: ".concat(barHeight, "px;\n  border-radius: ").concat(barBorder, "px;\n  background-color: ").concat(backgroundColor || (theme === null || theme === void 0 ? void 0 : theme.colors.disable), ";\n  overflow: hidden;\n  position: relative;\n  margin: 0.25rem 0;\n  align-items: center;\n  justify-content: ").concat(justify, ";\n  display: flex;\n  width: 100%;\n");
});
const Progress = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { height , border , progressPercentage , theme , color  } = param;
    return "\n  background-color: ".concat(color || (theme === null || theme === void 0 ? void 0 : theme.colors.primary), ";\n  position: absolute;\n  z-index: 1;\n  height: inherit;\n  border-radius: ").concat(border, "px;\n  height: ").concat(height, "px;\n  width: ").concat(progressPercentage, "%;\n  transition: width 0.3s ease-in-out;\n");
});
const ProgressBar = (param)=>{
    let { progress =0 , barColor , barHeight =4 , barBorder =barHeight / 2 , backgroundColor , barContent , justify  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBar, {
        barHeight: barHeight,
        barBorder: barBorder,
        backgroundColor: backgroundColor,
        justify: justify,
        children: [
            barContent,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Progress, {
                progressPercentage: progress,
                color: barColor,
                height: barHeight,
                border: barBorder
            })
        ]
    });
};


/***/ }),

/***/ 590498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ RelatedPromotionV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(853675);
/* harmony import */ var components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(243290);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





const renderDetailPromotionContent = (benefit, isCoupon)=>{
    const { gifts , voucher , discount  } = benefit;
    const renderAndText = " " + (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("v\xe0") + " ";
    const renderDiscount = ()=>{
        if (discount && Object.keys(discount).length) {
            const { percent , maxAmount , flat  } = discount;
            return percent !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("{{percent}}% ", {
                        percent: percent
                    }),
                    !!maxAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tối đa"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                                value: maxAmount
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ProductDetail_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledCurrency */ .DY, {
                value: flat || 0
            });
        }
    };
    const renderGifts = ()=>{
        if (gifts && gifts.length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: gifts.map((param, index)=>/*#__PURE__*/ {
                    let { name , quantity , imageUrl  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: " ".concat(quantity, " ").concat(name)
                            }),
                            !!imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                style: {
                                    objectFit: "contain",
                                    height: "20px",
                                    width: "20px"
                                },
                                src: imageUrl,
                                alt: name
                            }),
                            index !== gifts.length - 1 && ", "
                        ]
                    }, "".concat(index).concat(name));
                })
            });
        }
        return null;
    };
    const renderVoucher = ()=>{
        if (voucher && Object.keys(voucher).length) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                children: voucher.name ? "".concat(voucher.quantity, " ").concat(voucher.name) : "Voucher"
            });
        }
        return null;
    };
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderDiscount() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("giảm") + " ",
            renderDiscount(),
            renderDiscount() && renderGifts() && renderAndText,
            renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            renderGifts(),
            renderDiscount() && renderVoucher() && !renderGifts() && renderAndText,
            renderGifts() && renderVoucher() && ", ",
            renderVoucher() && !renderGifts() && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("tặng"),
            " ",
            renderVoucher()
        ]
    });
    if (!isCoupon) {
        let spinner = true;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(content, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(content.props.children, (element)=>{
                if (typeof element === "string" && spinner) {
                    if (!!element) {
                        spinner = false;
                        return element.charAt(0).toUpperCase() + element.slice(1);
                    }
                }
                return element;
            })
        });
    }
    return content;
};
const RelatedPromotionV2 = (param)=>{
    let { validPromotion  } = param;
    const { isDefault , benefit , condition , type , description  } = validPromotion;
    const isCoupon = !isDefault && type === "coupon";
    const isGiftCode = !isDefault && type === "gift-code";
    // Custom magento from PPM
    if (type === "qr") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: description || ""
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        children: [
            (isCoupon || isGiftCode) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("Nhập m\xe3"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        children: (condition === null || condition === void 0 ? void 0 : condition.coupon) || ""
                    }),
                    " "
                ]
            }),
            renderDetailPromotionContent(benefit, isCoupon || isGiftCode),
            " ",
            (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("cho đơn h\xe0ng"),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMin) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("từ"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMin
                    })
                ]
            }),
            !!(condition === null || condition === void 0 ? void 0 : condition.orderValueMax) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    " ",
                    (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("đến"),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Currency */ .F, {
                        value: condition.orderValueMax
                    })
                ]
            }),
            " ",
            !!(condition === null || condition === void 0 ? void 0 : condition.hasProductCondition) && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("c\xf3 sản phẩm n\xe0y"),
            isDefault && (0,i18n__WEBPACK_IMPORTED_MODULE_2__.t)("sites.shop-front.components.RelatedPromotion.0")
        ]
    });
};


/***/ }),

/***/ 192719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ RelateVideosAndPosts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(517293);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  line-height: 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 540px;\n  background-color: black;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







const YoutubeFrame = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 42609).then(__webpack_require__.bind(__webpack_require__, 742609)).then((mod)=>mod.YoutubeFrame), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(742609)
            ]
    }
});
const MAX_ITEMS_WITH_TWO_BLOCKS = 3;
const StyledH3 = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].h3(_templateObject());
const IFramePopupWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1());
const StyledCustomLink = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x)(_templateObject2());
const RelatedBlock = (props)=>{
    const { 0: youtubeLink , 1: setYoutubeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const { title , type , seeMoreUrl , items  } = props;
    const renderItem = (url, description)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
            gap: "s8",
            align: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, {
                    height: "56px",
                    width: "100px",
                    borderRadius: 6,
                    contain: true,
                    src: url,
                    imageWidth: 200
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                    width: "calc(100% - 100px - 16px)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                        line: 3,
                        level: 1,
                        children: description
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                padding: "s16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledH3, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                        gap: "s12",
                        direction: "column",
                        marginTop: "s12",
                        children: items.map((item, index)=>{
                            const { url , thumbnailUrl , description  } = item;
                            return type === "post" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCustomLink, {
                                href: url,
                                target: "_blank",
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                                onClick: ()=>setYoutubeLink(url),
                                style: {
                                    cursor: "pointer",
                                    width: "100%"
                                },
                                children: renderItem(thumbnailUrl, description)
                            }, "".concat(index).concat(url));
                        })
                    }),
                    !!seeMoreUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
                        href: seeMoreUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                            paddingTop: "s16",
                            align: "center",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                                variant: "link",
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Xem th\xeam nội dung"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .ChevronForwardFilled */ .O, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Modal */ .u, {
                visible: !!youtubeLink,
                width: "960px",
                onClose: ()=>setYoutubeLink(""),
                showCloseIcon: false,
                footer: false,
                contentStyle: {
                    padding: "0px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IFramePopupWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(YoutubeFrame, {
                        youtubeLink: youtubeLink
                    })
                })
            })
        ]
    });
};
const RelateVideosAndPosts = (props)=>{
    var ref, ref1, ref2, ref3;
    const { relatedPosts , relatedVideos  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref = relatedVideos.urls) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: relatedVideos.urls.map((video, index)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "VideoObject",
                                name: video.name,
                                description: video.description,
                                thumbnailUrl: video.thumbnailUrl,
                                uploadDate: typeof video.uploadDate === "number" ? new Date(video.uploadDate * 1000).toISOString() : "",
                                embedUrl: video.url
                            })
                        }
                    }, "".concat(index).concat(video.url));
                })
            }),
            !!(relatedPosts === null || relatedPosts === void 0 ? void 0 : (ref1 = relatedPosts.urls) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                marginTop: "s12",
                marginBottom: !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref2 = relatedVideos.urls) === null || ref2 === void 0 ? void 0 : ref2.length) ? "s0" : "s12",
                backgroundColor: "white",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedPosts.title || "",
                    type: "post",
                    seeMoreUrl: relatedPosts.seeMoreUrl,
                    items: relatedPosts.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , description  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: description || ""
                        };
                    })
                })
            }),
            !!(relatedVideos === null || relatedVideos === void 0 ? void 0 : (ref3 = relatedVideos.urls) === null || ref3 === void 0 ? void 0 : ref3.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b, {
                margin: [
                    "s12",
                    "s0"
                ],
                backgroundColor: "white",
                border: "s8",
                borderRadius: "m",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RelatedBlock, {
                    title: relatedVideos.title || "",
                    type: "video",
                    seeMoreUrl: relatedVideos.seeMoreUrl,
                    items: relatedVideos.urls.slice(0, MAX_ITEMS_WITH_TWO_BLOCKS).map((param)=>{
                        let { url , thumbnailUrl , name  } = param;
                        return {
                            url: url || "",
                            thumbnailUrl: thumbnailUrl || "",
                            description: name || ""
                        };
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 661497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(252661);
/* harmony import */ var rc_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(144303);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  &.rc-select {\n    width: 100%;\n    } // don't remove this\n  }\n\n  .rc-select-selector {\n    height: ",
        ";\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-single {\n    .rc-select-selector {\n      .rc-select-selection-placeholder {\n        left: 5px;\n        color: ",
        ";\n      }\n      .rc-select-selection-item {\n        color: ",
        ";\n        left: 5px;\n      }\n    }\n  }\n\n  .rc-select-selection-placeholder,\n  .rc-select-selection-item {\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    margin-left: 0.5rem;\n  }\n\n  &.rc-select-single:not(.rc-select-customize-input) {\n    .rc-select-selector {\n      .rc-select-selection-search-input {\n        background: ",
        ";\n        padding: ",
        ";\n        height: 2.5rem;\n        border-radius: ",
        ";\n        border: 1px solid\n          ",
        ";\n        &:hover {\n          border-color: ",
        ";\n        }\n        :focus,\n        :focus-within {\n          border-color: ",
        ";\n        }\n      }\n    }\n  }\n\n  &.rc-select-single:not(.rc-select-customize-input) {\n    .rc-select-selector {\n      border-style: none !important;\n    }\n    .rc-select-clear {\n      margin-top: 0.75rem;\n    }\n  }\n\n  .rc-select-arrow {\n    right: 12px;\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-clear {\n    right: 13px;\n    background-color: ",
        ";\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-dropdown {\n    margin-top: 4px;\n    padding: 0.25rem;\n    border-radius: ",
        ";\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n    border: none;\n    background-color: ",
        ";\n    min-height: auto;\n  }\n\n  .rc-select-item {\n    font-size: 13px;\n    padding: ",
        ";\n    height: 40px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  .rc-select-item-option-active,\n  .rc-select-item-option-selected {\n    background-color: ",
        ";\n    border-radius: ",
        ";\n  }\n\n  .rc-virtual-list,\n  .rc-virtual-list-holder,\n  .rc-virtual-list-holder-inner {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const Select = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, _objectSpread({
        removeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .DeleteCircleFilled */ .N, {
            color: "textSecondary",
            size: 16,
            className: "cursor-pointer"
        })
    }, props));
};
var _selectHeight, _selectInputPadding, _selectInputBorderRadius, _selectItemPadding;
const StyledSelect = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(rc_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject(), (p)=>(_selectHeight = p.selectHeight) !== null && _selectHeight !== void 0 ? _selectHeight : "40px", (p)=>p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder, (p)=>p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary, (p)=>p.disabled ? p.theme.colors.background : p.theme.colors.white, (p)=>(_selectInputPadding = p.selectInputPadding) !== null && _selectInputPadding !== void 0 ? _selectInputPadding : "0.25rem 2rem 0.25rem 0.75rem", (p)=>(_selectInputBorderRadius = p.selectInputBorderRadius) !== null && _selectInputBorderRadius !== void 0 ? _selectInputBorderRadius : p.theme.borderRadius.s, (p)=>p.disabled ? p.theme.colors.background : p.theme.colors.inputBorder, (param)=>{
    let { theme  } = param;
    return theme.colors.neutral;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.m;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (p)=>(_selectItemPadding = p.selectItemPadding) !== null && _selectItemPadding !== void 0 ? _selectItemPadding : "0.5rem 1rem", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.s;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.m;
});


/***/ }),

/***/ 742609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YoutubeFrame": function() { return /* binding */ YoutubeFrame; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);



const StyledIframe = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].iframe((param)=>{
    let { openInPopup  } = param;
    return "\n    position: relative;\n    height: 100%;\n    width: 100%;\n    pointer-events: ".concat(openInPopup ? "none" : "auto", ";\n");
});
const YoutubeFrame = (param)=>{
    let { embedId , youtubeLink , openInPopup =false  } = param;
    const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
    if (!videoEmbedId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIframe, {
        src: "https://www.youtube.com/embed/".concat(videoEmbedId),
        allowFullScreen: true,
        frameBorder: "0",
        openInPopup: openInPopup
    });
};
const getIdFromYoutubeLink = (url)=>{
    if (!url) return "";
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : "";
};


/***/ }),

/***/ 262665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ UPLOAD_VIDEO_PATHNAME; },
/* harmony export */   "dr": function() { return /* binding */ ACCEPTED_IMAGE_TYPES; },
/* harmony export */   "g9": function() { return /* binding */ UPLOAD_IMAGE_PATHNAME; },
/* harmony export */   "kI": function() { return /* binding */ UPLOAD_FILE_PRIVATE_PATHNAME; }
/* harmony export */ });
/* unused harmony exports UPLOAD_FILE_PATHNAME, UPLOAD_IMAGE_PRIVATE_PATHNAME */
const UPLOAD_IMAGE_PATHNAME = "/api/v2/upload/image?cloud=true&isPrivate=false";
const UPLOAD_FILE_PATHNAME = "/api/v2/upload/doc?cloud=true&isPrivate=false";
const UPLOAD_IMAGE_PRIVATE_PATHNAME = "/api/v2/upload/image?cloud=true&isPrivate=true";
const UPLOAD_FILE_PRIVATE_PATHNAME = "/api/v2/upload/doc?cloud=true&isPrivate=true";
const UPLOAD_VIDEO_PATHNAME = "/api/v2/upload/video?cloud=true&isPrivate=false";
const IMAGE_TYPE_PNG = "image/png";
const IMAGE_TYPE_JPEG = "image/jpeg";
const IMAGE_TYPE_JPG = "image/jpg";
const ACCEPTED_IMAGE_TYPES = [
    IMAGE_TYPE_JPEG,
    IMAGE_TYPE_JPG,
    IMAGE_TYPE_PNG, 
];


/***/ }),

/***/ 347822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollSmoothToIdWithOffset; },
/* harmony export */   "a": function() { return /* binding */ scrollSmoothToId; }
/* harmony export */ });
const scrollSmoothToId = (id)=>{
    const element = document.getElementById(id);
    element === null || element === void 0 ? void 0 : element.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
    });
};
const scrollSmoothToIdWithOffset = function(id) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
    const element = document.getElementById(id);
    if (!element) return;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 691018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ usePolicies; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./services/clients/api.ts
var api = __webpack_require__(44844);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ./services/public-service.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


api/* publicSettingApi.addInterceptor */.Wk.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
const publicService = {
    // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/15d54366/paths/api-v1-get-location-options/get
    getLocationOptions: async (domain)=>{
        var ref;
        const data = await api/* publicSettingApi.get */.Wk.get("/get-location-options", {
            params: {
                domain
            }
        });
        return (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.data) || [];
    },
    // api docs: https://apidoc.teko.vn/project-doc/approved/omni_retail/presentation_layer/public_bff/version/latest/operations/sale-policies
    getSalePoliciesBySku: (params, language)=>{
        return api/* publicSettingApi.get */.Wk.get("/sale-policies", {
            params: _objectSpread({}, params),
            headers: {
                "Accept-Language": language || "*"
            }
        }).then((param)=>{
            let { data  } = param;
            return Promise.resolve(data);
        });
    }
};

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
;// CONCATENATED MODULE: ./hooks/usePolicies.tsx
function usePolicies_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usePolicies_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usePolicies_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const OTHER_POLICIES = 0;
const convertPolicies = (policies)=>{
    return policies.map((el, index)=>({
            id: index,
            content: el.displayText,
            icon: el.iconUrl,
            detailUrl: el.detailUrl
        }));
};
const usePolicies = (sku, sellerId)=>{
    const { 0: policies , 1: setPolicies  } = (0,react.useState)([]);
    const { terminalId , currentLanguage , terminal , useTerminalId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { loading  } = (0,context_es/* useAuth */.aC)();
    (0,react.useEffect)(()=>{
        const fetchPolicies = ()=>{
            publicService.getSalePoliciesBySku(usePolicies_objectSpread({
                sku
            }, flags.epic_omni_1237 ? {
                sellerId
            } : {}, flags.epic_ecom_284 || useTerminalId ? {
                terminalId
            } : {
                terminalCode: terminal
            }), currentLanguage).then((param)=>{
                let { policies: value  } = param;
                return setPolicies(value.map((policy)=>_objectSpreadProps(usePolicies_objectSpread({}, policy), {
                        // after remove 305 --> displayText is required param
                        displayText: purify_default().sanitize(policy.displayText || "")
                    })));
            });
        };
        if (!!sku && !loading) {
            fetchPolicies();
        }
    }, [
        sku,
        sellerId,
        loading
    ]);
    const salePolicies = policies.filter((policies)=>policies.serviceGroupId !== OTHER_POLICIES);
    const otherPolicies = policies.filter((policies)=>policies.serviceGroupId === OTHER_POLICIES);
    return {
        policies: convertPolicies(policies),
        salePolicies: convertPolicies(salePolicies),
        otherPolicies: convertPolicies(otherPolicies)
    };
};


/***/ }),

/***/ 906825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useGetPriceDetailPage; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);



const useGetPriceDetailPage = ()=>{
    const { cartServiceV2  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useServices */ .Su)();
    const { payloadAddToCart  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { data: calculatePrice  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)([
        "/calculatePrice",
        payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku
    ], async ()=>{
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return undefined;
            return await cartServiceV2.calculatePrice({
                sku: payloadAddToCart.sku,
                quantity: 1
            });
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("Error occur when fetching calculatePrice: ".concat(e));
            return undefined;
        }
    }, {
        revalidateOnFocus: false
    });
    return {
        calculatePrice
    };
};


/***/ }),

/***/ 693442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ DefaultPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ./assets/default-promotion.svg
/* harmony default export */ var default_promotion = ("https://shopfront-cdn.tekoapis.com/_next/static/images/default-promotion-30ac7917388f7e0e58dcff2420e2c830.svg");
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-2.3.6-0bc101c0e7-4b2bbf6bc6.zip/node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(391547);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./modules/product-detail/shared/DefaultPromotions.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 16px 8px;\n  background: linear-gradient(\n    180deg,\n    rgba(250, 225, 76, 0.1) 4.81%,\n    rgba(250, 225, 76, 0) 100%\n  );\n  border: 1px solid #ffd591;\n  border-radius: 8px;\n  margin-top: -15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding-left: 0; // remove default padding of ul\n  margin: 0;\n  margin-left: 2rem;\n  img {\n    height: 20px;\n    width: 20px;\n    border-radius: 4px;\n    border: 1px solid #0000000f;\n    object-fit: contain;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




const DefaultPromotions = (props)=>{
    const { promotions  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        padding: [
            "s8",
            "s0"
        ],
        backgroundColor: "white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                paddingLeft: "s8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                    src: default_promotion,
                    width: "140px",
                    height: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
                    children: promotions.map((promotion, index)=>{
                        var ref, ref1;
                        // tier promotions will have no title
                        return !!promotion.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                weight: "regular",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        dangerouslySetInnerHTML: {
                                            __html: (purify_default()) === null || (purify_default()) === void 0 ? void 0 : (ref = (purify_default()).sanitize) === null || ref === void 0 ? void 0 : ref.call((purify_default()), promotion.title)
                                        },
                                        style: {
                                            whiteSpace: "pre-line"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                        weight: "regular",
                                        color: "#F89E33",
                                        children: (ref1 = promotion.highlightedDescriptions) === null || ref1 === void 0 ? void 0 : ref1[0]
                                    })
                                ]
                            })
                        }, "".concat(index).concat(promotion.promotionId)) : null;
                    })
                })
            })
        ]
    });
};
const PromotionsWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(_templateObject());
const StyledUl = emotion_styled_browser_esm["default"].ul(_templateObject1());


/***/ }),

/***/ 981282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ FlashSalePromotionBlock; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FlashSaleFilled.es.js
var FlashSaleFilled_es = __webpack_require__(576862);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/FireFlashsaleColored.es.js
var FireFlashsaleColored_es = __webpack_require__(767535);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CountdownTime/CountdownTime.es.js
var CountdownTime_es = __webpack_require__(883578);
;// CONCATENATED MODULE: ./assets/nl-desktop-flash-sale-background.svg
/* harmony default export */ var nl_desktop_flash_sale_background = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzY4IiBoZWlnaHQ9IjcyIiB2aWV3Qm94PSIwIDAgNzY4IDcyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjgwNl8xMjM3NDEpIj4KPHJlY3Qgd2lkdGg9Ijc2OCIgaGVpZ2h0PSI3MiIgcng9IjgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yODA2XzEyMzc0MSkiLz4KPHJlY3Qgd2lkdGg9IjkuODEwMDkiIGhlaWdodD0iOTEuMDkxNSIgdHJhbnNmb3JtPSJtYXRyaXgoMC44MTU2NjIgMC41Nzg1MjkgLTAuODE1NjYyIDAuNTc4NTI5IDIxOS42NTUgLTE3LjA2MzUpIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfMjgwNl8xMjM3NDEpIi8+CjxyZWN0IHdpZHRoPSIzLjcyMTIxIiBoZWlnaHQ9IjE0MC44NzIiIHRyYW5zZm9ybT0ibWF0cml4KDAuODE1NjYyIDAuNTc4NTI5IC0wLjgxNTY2MiAwLjU3ODUyOSAyNTAuOTA0IC0yNCkiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcl8yODA2XzEyMzc0MSkiLz4KPHJlY3Qgd2lkdGg9IjIwLjI0MDEiIGhlaWdodD0iMTA2LjEzMiIgdHJhbnNmb3JtPSJtYXRyaXgoMC44MTU2NjIgMC41Nzg1MjkgLTAuODE1NjYyIDAuNTc4NTI5IDM4OS45NTUgLTIyLjU5NzcpIiBmaWxsPSJ1cmwoI3BhaW50M19saW5lYXJfMjgwNl8xMjM3NDEpIi8+CjxyZWN0IHdpZHRoPSI5LjEyNTgyIiBoZWlnaHQ9IjEwMS44NDQiIHRyYW5zZm9ybT0ibWF0cml4KDAuODE1NjYyIDAuNTc4NTI5IC0wLjgxNTY2MiAwLjU3ODUyOSA0MDAuNTU2IC05LjI3NTM5KSIgZmlsbD0idXJsKCNwYWludDRfbGluZWFyXzI4MDZfMTIzNzQxKSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjgwNl8xMjM3NDEiIHgxPSIwIiB5MT0iMCIgeDI9IjU5MS41NDIiIHkyPSIzNjEuMDgyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGQTcwMEMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkY0MjE4Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl8yODA2XzEyMzc0MSIgeDE9IjQuOTA1MDQiIHkxPSItMy43MTYwOWUtMDkiIHgyPSI1LjM2MDAxIiB5Mj0iODMuNzQwOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRkZEMTJFIiBzdG9wLW9wYWNpdHk9IjAuNzMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkZEMzM4IiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDJfbGluZWFyXzI4MDZfMTIzNzQxIiB4MT0iMS44NjA2MSIgeTE9Ii01LjY5MTkzZS0wOSIgeDI9IjQuNjk4NTMiIHkyPSI4NC4zNDQ4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGRkQxMkUiIHN0b3Atb3BhY2l0eT0iMC43MyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRkQzMzgiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50M19saW5lYXJfMjgwNl8xMjM3NDEiIHgxPSIxMC4xMiIgeTE9Ii02LjU5ODM0ZS0wOSIgeDI9IjEwLjU3NjMiIHkyPSI5Mi41NzQ3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGRkQxMkUiIHN0b3Atb3BhY2l0eT0iMC43MyIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRkQzMzgiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50NF9saW5lYXJfMjgwNl8xMjM3NDEiIHgxPSI0LjU2MjkxIiB5MT0iLTYuMzMxNzVlLTA5IiB4Mj0iNS40OTQ2MyIgeTI9Ijg4LjgyNjgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRDEyRSIgc3RvcC1vcGFjaXR5PSIwLjczIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGRDMzOCIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjgwNl8xMjM3NDEiPgo8cmVjdCB3aWR0aD0iNzY4IiBoZWlnaHQ9IjcyIiByeD0iOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");
;// CONCATENATED MODULE: ./assets/nl-mobile-flashsale-background.svg
/* harmony default export */ var nl_mobile_flashsale_background = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/ProgressBar.tsx
var ProgressBar = __webpack_require__(514605);
;// CONCATENATED MODULE: ./components/FlashSalePromotion.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n  flex: 1 0 auto;\n  font-size: 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 15px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










const FlashSalePromotion = (_param)=>{
    var { endAt , message , progress  } = _param, rest = _objectWithoutProperties(_param, [
        "endAt",
        "message",
        "progress"
    ]);
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpreadProps(_objectSpread({
        background: isMobile ? nl_mobile_flashsale_background : nl_desktop_flash_sale_background
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                align: "middle",
                justify: "space-between",
                margin: [
                    "s4",
                    "s0"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSaleFilled_es/* FlashSaleFilled */.R, {
                                size: 24,
                                color: "#FFA940"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                                weight: "bold",
                                color: "white",
                                marginLeft: "s4",
                                children: "Flashsale"
                            })
                        ]
                    }),
                    endAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        align: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Caption */.YS, {
                                weight: "regular",
                                color: "white",
                                level: 1,
                                children: [
                                    (0,i18n.t)("Kết th\xfac sau"),
                                    ": "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCountDownTime, {
                                level: 2,
                                endAt: typeof endAt === "string" || typeof endAt === "number" ? new Date(endAt) : endAt,
                                renderDaysCountdownText: (duration)=>(0,i18n.t)("{{DurationDays}} ng\xe0y", {
                                        DurationDays: duration.days
                                    }),
                                weight: "bold",
                                marginLeft: "s4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* ProgressBar */.k, {
                    barHeight: 24,
                    progress: progress,
                    barColor: "#FA700C26",
                    backgroundColor: "white",
                    justify: progress === 100 ? "center" : "start",
                    barContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        marginLeft: "s4",
                        align: "middle",
                        style: {
                            zIndex: 100,
                            textTransform: "uppercase"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FireFlashsaleColored_es/* FireFlashsaleColored */.L, {
                                size: 20,
                                z: 2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                level: 1,
                                weight: "medium",
                                color: "#FA541C",
                                marginLeft: "s4",
                                children: message
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
const Wrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { background , theme  } = param;
    return '\n    background: url("'.concat(background, '");\n    padding: ').concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s4, " ").concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s8, ";\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n");
}, BaseProps_index_es/* CommonStyles */.F, "border-radius: 10px;");
const StyledCaption = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Caption */.YS)(_templateObject());
const StyledCountDownTime = (0,emotion_styled_browser_esm["default"])(CountdownTime_es/* CountdownTime */.v)(_templateObject1());

// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
;// CONCATENATED MODULE: ./modules/product-detail/shared/FlashSalePromotionBlock.tsx





const FlashSalePromotionBlock = ()=>{
    const { product , showFlashSale  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { total , used , endAt  } = (product === null || product === void 0 ? void 0 : product.flashSale) || {};
    const remain = typeof used === "number" && typeof total === "number" ? Math.min(total - used, (product === null || product === void 0 ? void 0 : product.totalAvailable) || Number.MAX_SAFE_INTEGER) : 0;
    const message = total === used || remain <= 0 ? (0,i18n.t)("Ch\xe1y h\xe0ng") : (0,i18n.t)("C\xf2n lại {{remain}}", {
        remain: remain
    });
    if (showFlashSale && typeof used === "number" && typeof total === "number") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        paddingTop: isMobile ? "s8" : "s0",
        padding: [
            "s8",
            "s0"
        ],
        backgroundColor: "white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashSalePromotion, {
            progress: Math.min(100 * (used / total), 100),
            message: message,
            endAt: endAt
        })
    });
    else return null;
};


/***/ }),

/***/ 812388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ MetaData; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var components_HeadSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(665207);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(534924);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);





const MetaData = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    const { product , primitiveProduct , serverRating  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useProductDetailState */ .W)();
    const { baseDomain , canonicalDomain  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    let canonical;
    if (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref = primitiveProduct.productInfo) === null || ref === void 0 ? void 0 : ref.canonical) {
        if (canonicalDomain) {
            canonical = "".concat(canonicalDomain, "/").concat(primitiveProduct.productInfo.canonical);
        } else if (baseDomain) {
            canonical = "".concat(baseDomain, "/").concat(primitiveProduct.productInfo.canonical);
        }
    }
    const data = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref1 = primitiveProduct.productInfo) === null || ref1 === void 0 ? void 0 : ref1.name,
        image: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref2 = primitiveProduct.productInfo) === null || ref2 === void 0 ? void 0 : ref2.imageUrl,
        brand: {
            "@type": "Brand",
            name: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref3 = primitiveProduct.productInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.brand) === null || ref4 === void 0 ? void 0 : ref4.name
        },
        offers: {
            "@type": "Offer",
            price: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref5 = primitiveProduct.prices) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.latestPrice) || 0,
            url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref7 = primitiveProduct.productInfo) === null || ref7 === void 0 ? void 0 : ref7.canonical),
            priceCurrency: "VND",
            itemCondition: "https://schema.org/NewCondition",
            availability: (primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) === null || !!(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.totalAvailable) ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        },
        url: "".concat(baseDomain, "/").concat(primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref8 = primitiveProduct.productInfo) === null || ref8 === void 0 ? void 0 : ref8.canonical),
        description: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref9 = primitiveProduct.productDetail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.seoInfo) === null || ref10 === void 0 ? void 0 : ref10.metaDescription,
        sku: primitiveProduct === null || primitiveProduct === void 0 ? void 0 : (ref11 = primitiveProduct.productInfo) === null || ref11 === void 0 ? void 0 : ref11.sku,
        category: (ref12 = primitiveProduct === null || primitiveProduct === void 0 ? void 0 : primitiveProduct.productInfo.categories) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.name,
        additionalProperty: product === null || product === void 0 ? void 0 : (ref14 = product.attributeGroups) === null || ref14 === void 0 ? void 0 : ref14.filter((att)=>!!att.value && att.parentId !== 0).map((att)=>({
                "@type": "PropertyValue",
                name: att.name,
                value: att.value
            })),
        aggregateRating: !!(serverRating === null || serverRating === void 0 ? void 0 : serverRating.totalReviews) ? {
            "@type": "AggregateRating",
            bestRating: "5",
            worstRating: "1",
            ratingValue: serverRating === null || serverRating === void 0 ? void 0 : serverRating.averageRating,
            reviewCount: serverRating === null || serverRating === void 0 ? void 0 : serverRating.totalReviews
        } : undefined,
        review: !!(serverRating === null || serverRating === void 0 ? void 0 : serverRating.reviews.length) ? serverRating.reviews.slice(0, 5).map((review)=>({
                "@type": "Review",
                datePublished: typeof review.createdAt === "number" ? new Date(review.createdAt * 1000).toISOString() : "",
                reviewBody: review.review.comment,
                author: {
                    "@type": "Person",
                    name: review.userName || "Th\xe0nh vi\xean ẩn danh"
                },
                reviewRating: {
                    "@type": "Rating",
                    bestRating: "5",
                    ratingValue: review.review.rating
                }
            })) : undefined
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(data)
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HeadSection__WEBPACK_IMPORTED_MODULE_4__/* .HeadSection */ .I, {
                canonical: canonical,
                title: (product === null || product === void 0 ? void 0 : (ref15 = product.seoInfo) === null || ref15 === void 0 ? void 0 : ref15.metaTitle) || (product === null || product === void 0 ? void 0 : product.name),
                description: (product === null || product === void 0 ? void 0 : (ref16 = product.seoInfo) === null || ref16 === void 0 ? void 0 : ref16.metaDescription) || false,
                keywords: product === null || product === void 0 ? void 0 : (ref17 = product.seoInfo) === null || ref17 === void 0 ? void 0 : ref17.metaKeyword,
                image: product === null || product === void 0 ? void 0 : (ref18 = product.images) === null || ref18 === void 0 ? void 0 : (ref19 = ref18[0]) === null || ref19 === void 0 ? void 0 : ref19.src
            })
        ]
    });
};


/***/ }),

/***/ 715292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReviewSection": function() { return /* binding */ ReviewSection; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Skeleton/Skeleton.es.js
var Skeleton_es = __webpack_require__(134128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/index.es.js
var Colors_index_es = __webpack_require__(743126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ./components/Select/Select.tsx
var Select = __webpack_require__(661497);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductReview/StarRating.tsx
var StarRating = __webpack_require__(111474);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Video/Video.es.js
var Video_es = __webpack_require__(441363);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RatingFilled.es.js
var RatingFilled_es = __webpack_require__(825078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UserProfileColored.es.js
var UserProfileColored_es = __webpack_require__(893555);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PlayOutlined.es.js
var PlayOutlined_es = __webpack_require__(418536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductVideo/ProductVideo.es.js
var ProductVideo_es = __webpack_require__(7297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var constants_index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.28.0-c19c5add1b-a0516b2e4f.zip/node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__(883667);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ReviewItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background-color: #00000040;\n  align-items: center;\n  justify-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 50%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  position: relative;\n  background: #000;\n  cursor: pointer;\n\n  video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








const Star = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, _objectSpread({
        size: 20,
        color: "#fcde04"
    }, props));
const ReviewItem = (param)=>{
    let { reviewData , showDivider ,  } = param;
    var ref, ref1, ref2, ref3;
    const { 0: previewVideo , 1: setPreviewVideo  } = (0,react.useState)(null);
    const { 0: previewImage , 1: setPreviewImage  } = (0,react.useState)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            align: "middle",
                            justify: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                    children: reviewData.userAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleImageAvatar, {
                                        src: reviewData.userAvatar,
                                        width: 40,
                                        height: 40
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileColored_es/* UserProfileColored */.G, {
                                        size: 40,
                                        color: "white"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    marginLeft: "s8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                            direction: "row",
                                            align: "center",
                                            gap: "s8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                    level: 4,
                                                    children: reviewData.userName || (0,i18n.t)("Th\xe0nh vi\xean ẩn danh")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                                    level: 3,
                                                    color: "#00000073",
                                                    children: (0,format/* default */.Z)(new Date(reviewData.createdAt * 1000), "dd/MM/yyyy HH:mm")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                            value: reviewData.review.rating,
                                            starSize: 13
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            weight: "regular",
                            marginTop: "s12",
                            children: reviewData.review.comment
                        }),
                        !!((ref = reviewData.review.images) === null || ref === void 0 ? void 0 : ref.length) || !!((ref1 = reviewData.review.videos) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "row",
                            gap: "s4",
                            marginTop: "s4",
                            align: "center",
                            children: [
                                (ref2 = reviewData.review.videos) === null || ref2 === void 0 ? void 0 : ref2.map((videoUrl, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedia, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoThumbnail, {
                                            onClick: ()=>setPreviewVideo(videoUrl),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_es/* Video */.n, {
                                                    src: videoUrl,
                                                    muted: true,
                                                    width: "100%",
                                                    height: "60px",
                                                    playsInline: true,
                                                    autoPlay: true,
                                                    preload: "metadata"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIconOverlay, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayOutlined_es/* PlayOutlined */.n, {
                                                        color: "white",
                                                        size: 28
                                                    })
                                                })
                                            ]
                                        })
                                    }, index)),
                                (ref3 = reviewData.review.images) === null || ref3 === void 0 ? void 0 : ref3.map((imageUrl, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedia, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                            src: imageUrl,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "8px",
                                            onClick: ()=>setPreviewImage(imageUrl)
                                        })
                                    }, index))
                            ]
                        }) : null
                    ]
                })
            }),
            !!showDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                color: "divider"
            }),
            previewVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: !!previewVideo,
                onClose: ()=>setPreviewVideo(null),
                width: "max-content",
                showCloseIcon: true,
                centeredBody: true,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                    url: previewVideo,
                    source: constants_index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM,
                    videoProps: {
                        width: "100%",
                        controls: true,
                        autoPlay: true,
                        style: {
                            maxWidth: "80vw",
                            maxHeight: "80vh"
                        }
                    }
                })
            }),
            previewImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: !!previewImage,
                onClose: ()=>setPreviewImage(null),
                width: "max-content",
                showCloseIcon: true,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                    src: previewImage,
                    width: "100%",
                    style: {
                        maxWidth: "80vw",
                        maxHeight: "80vh"
                    }
                })
            })
        ]
    });
};
const Avatar = emotion_styled_browser_esm["default"].div(_templateObject());
const StyledMedia = emotion_styled_browser_esm["default"].div(_templateObject1());
const StyleImageAvatar = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)(_templateObject2());
const VideoThumbnail = emotion_styled_browser_esm["default"].div(_templateObject3());
const PlayIconOverlay = emotion_styled_browser_esm["default"].div(_templateObject4());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ViewMoreReviewsButton.tsx



const ViewMoreReviewsButton = (param)=>{
    let { onClick , numberOfReviews ,  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
        align: "center",
        justify: "center",
        marginTop: "s24",
        marginBottom: "s16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
            variant: "link",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                level: 1,
                children: (0,i18n.t)("Xem th\xeam {{numberOfReviews}} đ\xe1nh gi\xe1", {
                    numberOfReviews
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ProductRatingList.tsx









const STAR_RATING = [
    5,
    4,
    3,
    2,
    1
];
const ProductRatingList = (param)=>{
    let { ratingData ,  } = param;
    const { data , reviews , hasMore , loadMore , noFilter , filterParams , setFilterParams , numberOfReviewsRemaining , setPage , isValidating ,  } = ratingData;
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const isSmallScreen = window.innerWidth < 360;
    return data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        backgroundColor: "white",
        padding: [
            "s16",
            "s8"
        ],
        paddingTop: "s0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
                gap: "s8",
                paddingBottom: "s16",
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Title */.Dx, {
                        marginRight: "s8",
                        children: [
                            (0,i18n.t)("Lọc đ\xe1nh gi\xe1"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: noFilter,
                        onClick: ()=>{
                            setFilterParams(undefined);
                            setPage(1);
                        },
                        children: (0,i18n.t)("Tất cả")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasImage,
                        onClick: ()=>{
                            setFilterParams({
                                hasImage: true
                            });
                            setPage(1);
                        },
                        children: (0,i18n.t)("C\xf3 h\xecnh ảnh")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasVideo,
                        onClick: ()=>{
                            setFilterParams({
                                hasVideo: true
                            });
                            setPage(1);
                        },
                        children: (0,i18n.t)("C\xf3 video")
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                        placeholder: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "row",
                            gapX: "s4",
                            align: "center",
                            children: [
                                (0,i18n.t)("Sao"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                    size: 16
                                })
                            ]
                        }),
                        options: STAR_RATING.map((star)=>({
                                value: star,
                                label: isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "row",
                                    gapX: "s4",
                                    align: "center",
                                    children: [
                                        star,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                            size: 16
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                    value: star,
                                    max: star,
                                    starSize: 15
                                })
                            })),
                        defaultValue: filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating,
                        labelRender: (item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "row",
                                gapX: "s4",
                                align: "center",
                                children: [
                                    item.value,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                        size: 16
                                    })
                                ]
                            }),
                        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                            size: 18,
                            style: {
                                marginTop: "11px"
                            }
                        }),
                        onSelect: (value)=>{
                            setFilterParams({
                                rating: value
                            });
                            setPage(1);
                        },
                        onInputKeyDown: (e)=>{
                            e.preventDefault();
                        },
                        menuItemSelectedIcon: null,
                        notFoundContent: null,
                        selectItemPadding: !isSmallScreen ? "0 0.25rem" : "0 1rem",
                        selectHeight: "36px",
                        style: {
                            border: "1px solid #E4E5F0",
                            borderRadius: "1rem"
                        }
                    }) : STAR_RATING.map((star, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterTab, {
                            isActive: (filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating) === star,
                            onClick: ()=>{
                                setFilterParams({
                                    rating: star
                                });
                                setPage(1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "row",
                                gapX: "s4",
                                align: "center",
                                children: [
                                    star,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                        size: 16
                                    })
                                ]
                            })
                        }, index);
                    })
                ]
            }),
            isValidating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_es/* Skeleton */.O, {
                height: "0.75rem",
                width: "80%",
                marginTop: "s16"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: reviews.length ? reviews.map((review, index)=>review ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem, {
                        reviewData: review,
                        showDivider: index < reviews.length - 1
                    }, index) : null) : null
            }),
            hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreReviewsButton, {
                onClick: loadMore,
                numberOfReviews: numberOfReviewsRemaining
            }) : null
        ]
    }) : null;
};
const FilterTab = emotion_styled_browser_esm["default"].div((param)=>{
    let { isActive  } = param;
    return "\n  padding: 8px;\n  border: 1px solid ".concat(isActive ? "#0200BC" : Colors_index_es/* themeColor.divider */.E.divider, ";\n  background-color: ").concat(isActive ? "#0200BC1A" : "#fff", ";\n  border-radius: 16px;\n  color: ").concat(isActive ? "#0200BC" : "black", ";\n  font-size: 12px;\n  line-height: 20px;\n  font-weight: 400;\n  align-items: center;\n  justify-self: center;\n  white-space: nowrap;\n  cursor: pointer;\n");
});
const StyledFlex = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(()=>"\n  max-width: 90vw;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth; \n  scrollbar-width: none;\n  -ms-overflow-style: none;\n");

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ./assets/product-no-rating.svg
/* harmony default export */ var product_no_rating = ("https://shopfront-cdn.tekoapis.com/_next/static/images/product-no-rating-0e8d9f3c324bf25bf643ac795de27ba4.svg");
// EXTERNAL MODULE: ./components/ProgressBar.tsx
var ProgressBar = __webpack_require__(514605);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Toast/hooks.es.js
var hooks_es = __webpack_require__(314408);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/index.es.js + 23 modules
var Form_index_es = __webpack_require__(826373);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Textarea.es.js
var Textarea_es = __webpack_require__(209705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ./constants/file.ts
var constants_file = __webpack_require__(262665);
// EXTERNAL MODULE: ./services/consumer.ts
var consumer = __webpack_require__(667913);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
;// CONCATENATED MODULE: ./assets/upload-file.svg
/* harmony default export */ var upload_file = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-upload-virtual-1aa0cc9cf4/0/cache/rc-upload-npm-4.11.0-6bf0a45901-6828051d49.zip/node_modules/rc-upload/es/index.js + 6 modules
var es = __webpack_require__(822295);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/MediaUploader.tsx
function MediaUploader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MediaUploader_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MediaUploader_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const MediaUploader = (_param)=>{
    var { children , fileList , maxItems =5 , onDelete  } = _param, restProps = _objectWithoutProperties(_param, [
        "children",
        "fileList",
        "maxItems",
        "onDelete"
    ]);
    const { getProcessEnv , isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const baseFileServiceUrl = getProcessEnv("BASE_FILE_SERVICE_API_URL");
    const uploaderProps = {
        action: (file)=>{
            if (file.type.includes("image")) return "".concat(baseFileServiceUrl).concat(constants_file/* UPLOAD_IMAGE_PATHNAME */.g9);
            return "".concat(baseFileServiceUrl).concat(constants_file/* UPLOAD_VIDEO_PATHNAME */.CX);
        },
        name: "file",
        accept: "image/*,video/*",
        multiple: true,
        headers: {
            Authorization: "Bearer ".concat((0,interceptor_es/* getAccessToken */.hP)())
        }
    };
    const isExceededMaxItems = typeof maxItems === "number" && !!(fileList === null || fileList === void 0 ? void 0 : fileList.length) && fileList.length >= maxItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            gap: isMobile ? "s4" : "s12",
            align: "start",
            flexWrap: "wrap",
            children: [
                fileList === null || fileList === void 0 ? void 0 : fileList.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ItemsWrapper, {
                        isMobile: isMobile,
                        children: [
                            item.type === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                src: (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.url) || "",
                                style: {
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    width: "100%",
                                    height: isMobile ? "55px" : "60px"
                                },
                                objectFit: "cover"
                            }),
                            item.type === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                                url: item.url,
                                source: constants_index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM,
                                videoProps: {
                                    width: "100%",
                                    height: "100%",
                                    preload: "none",
                                    playsInline: true,
                                    autoPlay: true,
                                    muted: true,
                                    controls: isMobile ? false : true
                                }
                            }),
                            item.status === "done" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: "1px",
                                    right: "4px"
                                },
                                onClick: ()=>onDelete(item.url),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined_es/* CloseOutlined */.X, {
                                    size: 16,
                                    color: "#A7ABC3"
                                })
                            }),
                            item.status === "uploading" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.4)",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 6
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                                    isLoading: true,
                                    size: 24
                                })
                            })
                        ]
                    }, index);
                }),
                !isExceededMaxItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, _objectSpreadProps(MediaUploader_objectSpread({}, uploaderProps, restProps), {
                    children: !!(fileList === null || fileList === void 0 ? void 0 : fileList.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWrapper, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        isMobile: isMobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: upload_file,
                            imageWidth: 48
                        })
                    }) : children
                }))
            ]
        })
    });
};
const ItemsWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { isMobile  } = param;
    return "\n  position: relative;\n  width: ".concat(isMobile ? "55px" : "60px", ";\n  height: ").concat(isMobile ? "55px" : "60px", ";\n  border-radius: 6px;\n  border: 1px solid #d9d9d9;\n");
});

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/ProductReview.tsx
function ProductReview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductReview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductReview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductReview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ProductReview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ProductReview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ProductReview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductReview_templateObject() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 30px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-self: center;\n"
    ]);
    ProductReview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductReview_templateObject1() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    ProductReview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductReview_templateObject2() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n"
    ]);
    ProductReview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductReview_templateObject3() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  line-height: 22px;\n  font-size: 14px;\n"
    ]);
    ProductReview_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










const MAXIMUM_COMMENT_LENGTH = 2000;
const MAX_NUMBER_OF_MEDIA_ITEMS = 5;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ProductReview = (param)=>{
    let { visible , onCloseModal , openSuccessModal , refetchReviewList ,  } = param;
    var ref;
    const toast = (0,hooks_es/* useToast */.p)();
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { 0: rating , 1: setRating  } = (0,react.useState)();
    const { 0: commentLength , 1: setCommentLength  } = (0,react.useState)(0);
    const { 0: fileList , 1: setFileList  } = (0,react.useState)([]);
    const toastShownRef = (0,react.useRef)(false);
    const isUploading = fileList.some((file)=>file.status === "uploading");
    const handleBeforeUpload = (file, fileListIncoming)=>{
        var ref;
        const incoming = (ref = fileListIncoming === null || fileListIncoming === void 0 ? void 0 : fileListIncoming.length) !== null && ref !== void 0 ? ref : 1;
        if (fileList.length + incoming > MAX_NUMBER_OF_MEDIA_ITEMS) {
            if (!toastShownRef.current) {
                var ref1;
                toastShownRef.current = true;
                toast === null || toast === void 0 ? void 0 : (ref1 = toast.error) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: (0,i18n.t)("Cảnh b\xe1o"),
                    placement: "topRight",
                    message: (0,i18n.t)("Cho ph\xe9p tối đa {{maxNumber}} ảnh/video.", {
                        maxNumber: MAX_NUMBER_OF_MEDIA_ITEMS
                    })
                });
                setTimeout(()=>{
                    toastShownRef.current = false;
                }, 0);
            }
            return false;
        }
        if (!file.type || !constants_file/* ACCEPTED_IMAGE_TYPES.includes */.dr.includes(file.type) && !file.type.startsWith("video")) {
            var ref2;
            toast === null || toast === void 0 ? void 0 : (ref2 = toast.error) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                title: (0,i18n.t)("C\xf3 lỗi"),
                placement: "topRight",
                message: (0,i18n.t)("File kh\xf4ng hợp lệ")
            });
            return false;
        }
        if (file.size > MAX_FILE_SIZE) {
            var ref3;
            toast === null || toast === void 0 ? void 0 : (ref3 = toast.error) === null || ref3 === void 0 ? void 0 : ref3.call(toast, {
                title: (0,i18n.t)("C\xf3 lỗi"),
                placement: "topRight",
                message: (0,i18n.t)("File kh\xf4ng được vượt qu\xe1 {{max}}MB", {
                    max: 10
                })
            });
            return false;
        }
        const url = URL.createObjectURL(file);
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        setFileList((prev)=>[
                ...prev,
                {
                    file,
                    url,
                    type: isImage ? "image" : isVideo ? "video" : "other",
                    status: "uploading"
                }, 
            ]);
        return true;
    };
    const uploaderProps = {
        beforeUpload: handleBeforeUpload,
        onSuccess: (res, file)=>{
            setFileList((prev)=>prev.map((item)=>item.file === file ? ProductReview_objectSpreadProps(ProductReview_objectSpread({}, item), {
                        status: "done",
                        url: res.url,
                        image_url: res.image_url
                    }) : item));
        },
        onDelete: (fileUrl)=>setFileList(fileList.filter((file)=>file.url !== fileUrl)),
        fileList,
        onError (_, file) {
            const newFileList = fileList.filter((item)=>item.file.uid === file.uid);
            setFileList(newFileList);
        },
        maxItems: MAX_NUMBER_OF_MEDIA_ITEMS
    };
    const handleCreateProductReview = async ()=>{
        var ref, ref1;
        if ((product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id) && ((ref1 = product.seller) === null || ref1 === void 0 ? void 0 : ref1.id) && rating) {
            const getMediaUrls = (type)=>{
                return fileList.filter((file)=>file.type === type).map((item)=>item.url);
            };
            try {
                var ref2;
                const payload = {
                    productUrl: window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.href,
                    rating,
                    sellerId: product.seller.id,
                    review: {
                        comment: form.getFieldValue("comment"),
                        images: getMediaUrls("image"),
                        videos: getMediaUrls("video")
                    }
                };
                await (0,consumer/* createProductReview */.nE)(product.productGroup.id, payload);
                onCloseModal();
                openSuccessModal();
                refetchReviewList();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                var ref3, ref4, ref5;
                const traceId = e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.error) === null || ref4 === void 0 ? void 0 : ref4.traceId;
                (ref5 = toast.error) === null || ref5 === void 0 ? void 0 : ref5.call(toast, {
                    title: (0,i18n.t)("C\xf3 lỗi"),
                    message: "[".concat(traceId, "] ").concat((0,i18n.t)("C\xf3 lỗi xảy ra. Vui l\xf2ng thử lại sau!"))
                });
                dist_index_es/* logger.error */.k.error("Error occur when createProductReview: ".concat(e));
            }
        } else {
            var ref6, ref7;
            dist_index_es/* logger.error */.k.error("Missing productId or sellerId or rating", product === null || product === void 0 ? void 0 : (ref6 = product.productGroup) === null || ref6 === void 0 ? void 0 : ref6.id, product === null || product === void 0 ? void 0 : (ref7 = product.seller) === null || ref7 === void 0 ? void 0 : ref7.id, rating);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
        visible: visible,
        borderRadius: "16px",
        width: isMobile ? "90%" : 480,
        showCloseIcon: true,
        onClose: onCloseModal,
        okText: "",
        cancelText: "",
        contentStyle: {
            padding: 0
        },
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                children: (0,i18n.t)("Đ\xe1nh gi\xe1 sản phẩm")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody_es/* ModalBody */.f, {
                paddingLeft: "s16",
                paddingRight: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        border: "1px solid divider",
                        borderRadius: "m",
                        align: "center",
                        padding: "s8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleImage, {
                                    src: (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0].src) || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                direction: "column",
                                marginLeft: "s16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                    level: 2,
                                    children: product === null || product === void 0 ? void 0 : product.displayName
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        marginTop: "s16",
                        padding: [
                            "s16",
                            "s24"
                        ],
                        backgroundColor: "#fafafa",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                align: "center",
                                justify: "center",
                                direction: "column",
                                marginBottom: "s24",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        marginBottom: "s8",
                                        children: (0,i18n.t)("Bạn c\xf3 h\xe0i l\xf2ng về sản phẩm?")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReview_StarRating, {
                                        children: Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, {
                                                size: isMobile ? 28 : 32,
                                                style: {
                                                    marginLeft: "0.5rem",
                                                    marginRight: "0.5rem"
                                                },
                                                onClick: ()=>setRating(index + 1),
                                                color: rating && index + 1 <= rating ? "#fcde04" : "#C4D1FF80"
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form */.l, {
                                layout: "vertical",
                                form: form,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        children: (0,i18n.t)("Chia sẻ nhận x\xe9t về sản phẩm")
                                    }),
                                    style: {
                                        marginBottom: 0
                                    },
                                    name: "comment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea_es/* Textarea */.g, {
                                        rows: 4,
                                        borderRadius: "l",
                                        maxLength: MAXIMUM_COMMENT_LENGTH,
                                        onChange: (value)=>setCommentLength(value.length)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                justify: "space-between",
                                align: "start",
                                marginTop: "s0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaUploader, ProductReview_objectSpreadProps(ProductReview_objectSpread({}, uploaderProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                            level: 1,
                                            color: "link",
                                            children: (0,i18n.t)("Th\xeam ảnh/video")
                                        })
                                    })),
                                    (!isMobile || fileList.length < MAX_NUMBER_OF_MEDIA_ITEMS - 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        color: "#8C8C8C",
                                        children: "".concat(commentLength, "/").concat(MAXIMUM_COMMENT_LENGTH)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                paddingLeft: "s40",
                paddingRight: "s40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    width: "100%",
                    variant: "primary",
                    borderRadius: "m",
                    onClick: handleCreateProductReview,
                    disabled: isUploading,
                    children: (0,i18n.t)("Gửi đ\xe1nh gi\xe1")
                })
            })
        ]
    });
};
const ProductImage = emotion_styled_browser_esm["default"].div(ProductReview_templateObject());
const ProductReview_StarRating = emotion_styled_browser_esm["default"].div(ProductReview_templateObject1());
const StyleImage = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)(ProductReview_templateObject2());
const StyledBody = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)(ProductReview_templateObject3());

;// CONCATENATED MODULE: ./assets/thank-for-rating.svg
/* harmony default export */ var thank_for_rating = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/RatingSuccessModal.tsx
function RatingSuccessModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RatingSuccessModal_templateObject() {
    const data = RatingSuccessModal_taggedTemplateLiteral([
        "\n  width: 64px;\n  height: 64px;\n"
    ]);
    RatingSuccessModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RatingSuccessModal_templateObject1() {
    const data = RatingSuccessModal_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n"
    ]);
    RatingSuccessModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





const DURATION = 5;
const RatingSuccessModal = (param)=>{
    let { show , onClose ,  } = param;
    const { 1: setSecondsLeft  } = (0,react.useState)(DURATION); // auto close modal after 5s
    const { 0: running , 1: setRunning  } = (0,react.useState)(true);
    const timerRef = (0,react.useRef)();
    // Reset when modal opens/closes or duration changes
    (0,react.useEffect)(()=>{
        if (show) {
            setSecondsLeft(DURATION);
            setRunning(true);
        } else {
            setRunning(false);
            clearInterval(timerRef.current);
        }
        return ()=>clearInterval(timerRef.current);
    }, [
        show
    ]);
    // Start / stop interval
    (0,react.useEffect)(()=>{
        clearInterval(timerRef.current);
        if (!show) return;
        if (!running) return;
        timerRef.current = setInterval(()=>{
            setSecondsLeft((s)=>{
                if (s <= 1) {
                    // time's up: close modal
                    clearInterval(timerRef.current);
                    // call onClose on the next tick so UI updates cleanly
                    onClose();
                    return 0;
                }
                return s - 1;
            });
        }, 1000);
        return ()=>clearInterval(timerRef.current);
    }, [
        running,
        show,
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
        visible: show,
        borderRadius: "l",
        width: 446,
        contentStyle: {
            padding: 0
        },
        okText: "",
        cancelText: "",
        showCloseIcon: false,
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody_es/* ModalBody */.f, {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                            src: thank_for_rating,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: (0,i18n.t)("Cảm ơn bạn đ\xe3 đ\xe1nh gi\xe1!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    width: "100%",
                    variant: "primary",
                    borderRadius: "m",
                    onClick: ()=>{
                        onClose();
                        setRunning(false);
                        clearInterval(timerRef.current);
                    },
                    children: (0,i18n.t)("Đ\xf3ng")
                })
            })
        ]
    });
};
const ImageWrapper = emotion_styled_browser_esm["default"].div(RatingSuccessModal_templateObject());
const Text = emotion_styled_browser_esm["default"].div(RatingSuccessModal_templateObject1());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/RatingOverview.tsx
function RatingOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RatingOverview_templateObject() {
    const data = RatingOverview_taggedTemplateLiteral([
        "\n  .button-text {\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 24px;\n  }\n"
    ]);
    RatingOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const RatingOverview = (param)=>{
    let { ratingData ,  } = param;
    const { isMobile , epicOmni1550HideReviewButton  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { showModal  } = (0,hook_es/* useModal */.d)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const { 0: showProductReview , 1: setShowProductReview  } = (0,react.useState)(false);
    const { 0: showRatingSuccessModal , 1: setShowRatingSuccessModal  } = (0,react.useState)(false);
    const { averageRating , totalReviews , ratingCounts , setFilterParams , setPage , refreshReviewList ,  } = ratingData;
    const sortedRatingCounts = (0,react.useMemo)(()=>{
        return ratingCounts === null || ratingCounts === void 0 ? void 0 : ratingCounts.sort((a, b)=>b.star - a.star);
    }, [
        ratingCounts
    ]);
    const handleUnauthenticatedUser = ()=>{
        showModal({
            size: "m",
            title: (0,i18n.t)("Th\xf4ng b\xe1o"),
            centeredTitle: true,
            okText: (0,i18n.t)("Đăng nhập"),
            cancelText: (0,i18n.t)("Đ\xf3ng"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                direction: "column",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    marginTop: "s4",
                    children: (0,i18n.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
                })
            }),
            alignFooter: "center",
            onOk: ()=>authService.login()
        });
    };
    const writeProductReview = ()=>{
        if (!(user === null || user === void 0 ? void 0 : user.userId)) {
            handleUnauthenticatedUser();
            return;
        }
        setShowProductReview(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                padding: "s8",
                backgroundColor: "white",
                children: ratingData.isValidating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                    isLoading: true,
                    size: 40
                }) : !!totalReviews ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "center",
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: !isMobile ? 2 : 12,
                            style: {
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                                        span: !isMobile ? 12 : 6,
                                        style: {
                                            alignItems: "center",
                                            justifyItems: !isMobile ? "center" : "start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Heading */.X6, {
                                                marginRight: "s4",
                                                weight: "bold",
                                                style: {
                                                    fontSize: "40px",
                                                    lineHeight: "56px"
                                                },
                                                children: [
                                                    averageRating,
                                                    "/5"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                                value: averageRating || 0,
                                                starSize: 20,
                                                gap: 8
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                                marginTop: "s8",
                                                weight: "regular",
                                                children: [
                                                    totalReviews,
                                                    " ",
                                                    (0,i18n.t)("lượt đ\xe1nh gi\xe1")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: !isMobile ? 12 : 6,
                                        style: {
                                            display: "flex",
                                            justifyContent: !isMobile ? "center" : "end"
                                        },
                                        marginTop: "s8",
                                        children: !epicOmni1550HideReviewButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReviewButton, {
                                            variant: "primary",
                                            borderRadius: "m",
                                            onClick: writeProductReview,
                                            children: (0,i18n.t)("Viết đ\xe1nh gi\xe1")
                                        })
                                    })
                                ]
                            })
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                            color: "divider",
                            orientation: "vertical",
                            width: "100px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                color: "divider",
                                orientation: "horizontal"
                            })
                        }),
                        sortedRatingCounts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: !isMobile ? 8 : 12,
                            children: sortedRatingCounts.map((item)=>{
                                const percent = totalReviews > 0 ? item.count / totalReviews * 100 : 0;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    align: "middle",
                                    justify: "start",
                                    margin: [
                                        "s8",
                                        "s0"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: 1,
                                            marginRight: "s8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                                align: "middle",
                                                justify: "end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                        marginRight: "s4",
                                                        weight: "medium",
                                                        children: item.star
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, {
                                                        size: 14,
                                                        color: "support"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: !isMobile ? 7 : 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* ProgressBar */.k, {
                                                barHeight: 8,
                                                progress: percent,
                                                backgroundColor: Colors_index_es/* themeColor.divider */.E.divider,
                                                barColor: "#0300be"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: !isMobile ? 3.5 : 4,
                                            marginLeft: "s8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                                weight: "regular",
                                                children: [
                                                    item.count,
                                                    " ",
                                                    (0,i18n.t)("lượt đ\xe1nh gi\xe1")
                                                ]
                                            })
                                        })
                                    ]
                                }, item.star);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_es/* Skeleton */.O, {
                            height: "0.75rem",
                            width: "50%"
                        })
                    ]
                }) : !epicOmni1550HideReviewButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "column",
                    align: "center",
                    gap: "s16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: product_no_rating,
                            width: 160,
                            height: 93
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            weight: isMobile ? "regular" : "medium",
                            style: {
                                fontSize: isMobile ? 13 : 15
                            },
                            children: (0,i18n.t)("H\xe3y trở th\xe0nh người đầu ti\xean đ\xe1nh gi\xe1 sản phẩm n\xe0y")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReviewButton, {
                            variant: "primary",
                            borderRadius: "m",
                            onClick: writeProductReview,
                            children: (0,i18n.t)("Viết đ\xe1nh gi\xe1")
                        })
                    ]
                })
            }),
            !!showProductReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReview, {
                visible: showProductReview,
                onCloseModal: ()=>setShowProductReview(false),
                openSuccessModal: ()=>setShowRatingSuccessModal(true),
                refetchReviewList: ()=>{
                    setFilterParams(undefined);
                    setPage(1);
                    refreshReviewList();
                }
            }),
            !!showRatingSuccessModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingSuccessModal, {
                show: showRatingSuccessModal,
                onClose: ()=>setShowRatingSuccessModal(false)
            })
        ]
    });
};
const WriteReviewButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(RatingOverview_templateObject());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/ReviewSection.tsx
function ReviewSection_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ReviewSection_templateObject() {
    const data = ReviewSection_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid #ebeaea;\n"
    ]);
    ReviewSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = ()=>{
    const { productRatingData  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { epicOmni1550HideReviewButton  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    // Hide review section when this config on & no rating data
    if (epicOmni1550HideReviewButton && !productRatingData.totalReviews) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        id: "review-section",
        backgroundColor: "white",
        borderRadius: "xl",
        padding: "s8",
        margin: [
            "s8",
            "s0"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlockHeader, {
                title: (0,i18n.t)("Đ\xe1nh gi\xe1")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingOverview, {
                ratingData: productRatingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                color: "divider",
                gap: "16px"
            }),
            !!productRatingData.totalReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRatingList, {
                ratingData: productRatingData
            })
        ]
    });
};
const StyledBlockHeader = (0,emotion_styled_browser_esm["default"])(BlockHeader_es/* BlockHeader */.t)(ReviewSection_templateObject());


/***/ }),

/***/ 111474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(825078);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(743126);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(408797);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);




const StarRating = (props)=>{
    const { value , max =5 , starSize =20 , ratedColor =_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.support */ .E.support , unratedColor =_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__/* .themeColor.divider */ .E.divider , gap =2 ,  } = props;
    const stars = Array.from({
        length: max
    }, (_, i)=>i + 1);
    const fullStars = Math.floor(value);
    const starPercentage = value - fullStars;
    const hasHalfStar = starPercentage >= 0.1 && starPercentage < 1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
        align: "middle",
        width: "fit-content",
        style: {
            gap: gap
        },
        children: stars.map((star)=>{
            if (star <= fullStars) {
                // full star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                    size: starSize,
                    color: ratedColor
                }, star);
            } else if (star === fullStars + 1 && hasHalfStar) {
                // half star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        position: "relative",
                        width: starSize,
                        height: starSize
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                            size: starSize,
                            color: unratedColor,
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "".concat(starPercentage * 100, "%"),
                                height: "100%",
                                overflow: "hidden"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                                size: starSize,
                                color: ratedColor,
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0
                                }
                            })
                        })
                    ]
                }, star);
            } else {
                // empty star
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .RatingFilled */ .A, {
                    size: starSize,
                    color: unratedColor
                }, star);
            }
        })
    });
};


/***/ }),

/***/ 555082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ReviewSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ui_review__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(885541);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(983546);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(842918);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  .title {\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = (param)=>{
    let { product , wrapperBorderRadius  } = param;
    var ref, ref1;
    const { colors , borderRadius  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)();
    const { tekReviewAppId  } = (0,hooks__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { user , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)();
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    if (!tekReviewAppId) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        wrapperBorderRadius: wrapperBorderRadius,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBlockHeader, {
                title: "Đ\xe1nh gi\xe1 sản phẩm",
                borderColor: "#ebeaea"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui_review__WEBPACK_IMPORTED_MODULE_1__/* .TekReview */ .O, {
                appId: tekReviewAppId,
                entity: {
                    key: product.sku,
                    imageUrl: ((ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src) || "",
                    title: product.name
                },
                theme: {
                    colors: {
                        primary: colors.primary,
                        primaryActive: colors.primary600,
                        primaryHover: colors.primary700
                    },
                    borderRadius: borderRadius.s
                },
                reviewer: user ? {
                    displayName: user.name,
                    avatarUrl: user.avatar,
                    email: user.email,
                    phoneNumber: user.telephone
                } : undefined,
                onRequestLogin: ()=>setShow(true)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Modal */ .u, {
                visible: show,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đăng nhập"),
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Hủy"),
                onOk: ()=>{
                    authService === null || authService === void 0 ? void 0 : authService.login(window.location.href);
                },
                onCancel: ()=>{
                    setShow(false);
                },
                footer: true,
                onBackDrop: ()=>setShow(false),
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
            })
        ]
    });
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div((param)=>{
    let { wrapperBorderRadius  } = param;
    return "\n  position: relative;\n  background-color: #fff;\n  margin-top: 8px;\n  margin-bottom: 0.5rem;\n  border-radius: ".concat(wrapperBorderRadius || "0px", ";\n");
});
const StyledBlockHeader = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .BlockHeader */ .t)(_templateObject(), (props)=>props.borderColor);


/***/ }),

/***/ 795021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ TierPromotions; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(628382);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/ButtonChevron/ButtonChevron.es.js
var ButtonChevron_es = __webpack_require__(781662);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
;// CONCATENATED MODULE: ./assets/promotion-badge.svg
/* harmony default export */ var promotion_badge = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM0OTBfNTgwMykiPgo8cGF0aCBkPSJNLTEuNzE2NjFlLTA1IDkuOTk5OTlDLTEuNzE2NjFlLTA1IDguNjQ0OTkgMC41OTQ5ODIgNy4zNjY2NSAxLjYwNDE1IDYuNTYzMzJDMS40ODc0OCA1LjIxMTY1IDEuOTcwODIgMy44ODc0OSAyLjkyOTE1IDIuOTI4MzJDMy44ODc0OCAxLjk3MDgyIDUuMjA4MzIgMS40ODU4MiA2LjQ5MzMyIDEuNjMyNDlDOC4xNzE2NSAtMC40OTc1MTQgMTEuNzk3NSAtMC41Mzc1MTQgMTMuNDM2NiAxLjYwMzMyQzE2LjEzMDggMS4yODMzMiAxOC43MjE2IDMuODE5OTkgMTguMzY2NiA2LjQ5MzMyQzIwLjQ5NjYgOC4xNzE2NSAyMC41Mzc1IDExLjc5NzUgMTguMzk1OCAxMy40Mzc1QzE4LjUxMjUgMTQuNzg5MiAxOC4wMjkxIDE2LjExMzMgMTcuMDcwOCAxNy4wNzI1QzE2LjExMjUgMTguMDMgMTQuNzkgMTguNTE1IDEzLjUwNjYgMTguMzY4M0MxMS44MjgzIDIwLjQ5ODMgOC4yMDI0OCAyMC41MzgzIDYuNTYzMzIgMTguMzk3NUM1LjIxMzMyIDE4LjUxMzMgMy44ODgzMiAxOC4wMzE3IDIuOTI5MTUgMTcuMDcyNUMxLjk3MTY1IDE2LjExNDIgMS40ODgzMiAxNC43ODkyIDEuNjMzMzIgMTMuNTA4M0MwLjU5NDk4MiAxMi42MzUgLTEuNzE2NjFlLTA1IDExLjM1NjcgLTEuNzE2NjFlLTA1IDEwLjAwMTdWOS45OTk5OVpNMTMuMzMzMyA3LjQ5OTk5QzEzLjMyODMgNi40MDk5OSAxMS42NzE2IDYuNDA5OTkgMTEuNjY2NiA3LjQ5OTk5QzExLjY3MTYgOC41ODk5OSAxMy4zMjgzIDguNTg5OTkgMTMuMzMzMyA3LjQ5OTk5Wk0xMC45NzMzIDEyLjk2MjVDMTEuMjMgMTMuMzQ4MyAxMS43NTA4IDEzLjQ0NjcgMTIuMTI5MSAxMy4xOTMzQzEyLjUxMjUgMTIuOTM4MyAxMi42MTU4IDEyLjQyMDggMTIuMzYgMTIuMDM3NUw5LjAyNjY1IDcuMDM3NDlDOC43NzE2NSA2LjY1NDk5IDguMjU0OTggNi41NDk5OSA3Ljg3MDgyIDYuODA2NjVDNy40ODc0OCA3LjA2MTY1IDcuMzg0MTUgNy41NzkxNSA3LjYzOTk4IDcuOTYyNDlMMTAuOTczMyAxMi45NjI1Wk03LjQ5OTk4IDEzLjMzMzNDOC41ODk5OCAxMy4zMjgzIDguNTg5OTggMTEuNjcxNyA3LjQ5OTk4IDExLjY2NjdDNi40MDk5OCAxMS42NzE3IDYuNDA5OTggMTMuMzI4MyA3LjQ5OTk4IDEzLjMzMzNaIiBmaWxsPSIjMDA5NzNDIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzQ5MF81ODAzIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgMjAgMCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/cart/utils/index.ts
var utils = __webpack_require__(739069);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./modules/product-detail/shared/TierPromotion.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: #00973c;\n  font-weight: 500;\n\n  &:hover {\n    color: #006b2a;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  max-height: 600px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  padding-left: 0; // remove default padding of ul\n  margin-left: 2rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








const MAX_DISPLAY_DESCRIPTIONS = 3;
const TierPromotions = (props)=>{
    const { productPromotions , isApplicableWithCombo =true , maxLinesBeforeEllipsis =1 , isCustomerTierPromotions =false ,  } = props;
    const { isMobile , epicOmni1643  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: showDetail , 1: setShowDetail  } = (0,react.useState)(false);
    // all promotions of an item (not being grouped)
    const allItemPromotions = (0,utils/* flattenPromotionsFromPromotionGroups */.Ou)(productPromotions);
    // all tier descriptions of an item (not being grouped)
    const allItemTierDescriptions = (0,react.useMemo)(()=>{
        const flattedTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.tierDescriptions || [], 
            ], []) : [];
        return flattedTierDescriptions.length > 0 ? flattedTierDescriptions.filter((tierDesc)=>!!tierDesc.descriptions.length) : [];
    }, [
        allItemPromotions
    ]);
    const allItemHightLightDescriptions = (0,react.useMemo)(()=>{
        const flattedHightLightDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousHightLightDescriptions, currentPromotion)=>{
            var ref;
            return !!((ref = currentPromotion.highlightedDescriptions) === null || ref === void 0 ? void 0 : ref.length) ? [
                ...previousHightLightDescriptions,
                ...currentPromotion.highlightedDescriptions, 
            ] : previousHightLightDescriptions;
        }, []) : [];
        return flattedHightLightDescriptions;
    }, [
        allItemPromotions
    ]);
    const allItemCustomerTierDescription = (0,react.useMemo)(()=>{
        const flattedCustomerTierDescriptions = !!allItemPromotions.length ? allItemPromotions.reduce((previousTierDescriptions, currentPromotion)=>[
                ...previousTierDescriptions,
                ...currentPromotion.customerTierDescriptions || [], 
            ], []) : [];
        return flattedCustomerTierDescriptions;
    }, [
        allItemPromotions
    ]);
    // displaying tier descriptions limit to MAX_DISPLAY_DESCRIPTIONS
    const displayTierDescriptions = (0,react.useMemo)(()=>{
        return allItemTierDescriptions.length > MAX_DISPLAY_DESCRIPTIONS ? allItemTierDescriptions.slice(0, MAX_DISPLAY_DESCRIPTIONS) : allItemTierDescriptions;
    }, [
        allItemTierDescriptions
    ]);
    const handleCloseDetailModal = ()=>setShowDetail(false);
    const renderDetailContent = ()=>{
        return allItemTierDescriptions.map((tierDesc, index)=>{
            var ref;
            return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(TierDescList, {
                marginBottom: index !== allItemTierDescriptions.length - 1 ? "8px" : "0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: tierDesc.title
                    }),
                    ":",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    tierDesc.descriptions.map((desc, subIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: desc
                        }, "".concat(index, "-").concat(subIndex)))
                ]
            }, index) : null;
        });
    };
    if (!allItemTierDescriptions.length && !isCustomerTierPromotions || isCustomerTierPromotions && !allItemCustomerTierDescription.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!displayTierDescriptions.length || !!allItemCustomerTierDescription.length && isCustomerTierPromotions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                padding: [
                    "s8",
                    "s0"
                ],
                backgroundColor: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PromotionBox, {
                    borderRadius: "m",
                    padding: "s8",
                    border: epicOmni1643 ? undefined : "1px solid #00973c33",
                    epicOmni1643: epicOmni1643,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabel, {
                            epicOmni1643: epicOmni1643,
                            children: [
                                !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: promotion_badge,
                                    alt: "Promotion Badge"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                    level: 1,
                                    weight: "medium",
                                    color: epicOmni1643 ? "white" : undefined,
                                    children: isCustomerTierPromotions ? (0,i18n.t)("Ưu đ\xe3i kh\xe1ch h\xe0ng th\xe0nh vi\xean") : (0,i18n.t)("Mua nhiều th\xeam Ưu đ\xe3i")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                            marginTop: "s28",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
                                children: isCustomerTierPromotions ? allItemCustomerTierDescription.map((tierDesc, index)=>!!tierDesc.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                            weight: "regular",
                                            line: maxLinesBeforeEllipsis,
                                            color: "#000",
                                            marginBottom: "s4",
                                            children: [
                                                tierDesc.title,
                                                " ",
                                                tierDesc.description
                                            ]
                                        }, index)
                                    }) : null) : displayTierDescriptions.map((tierDesc, index)=>{
                                    var ref, ref1;
                                    return ((ref = tierDesc.descriptions) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                            weight: "regular",
                                            line: maxLinesBeforeEllipsis,
                                            color: "#000",
                                            marginBottom: "s4",
                                            children: [
                                                tierDesc.title,
                                                " ",
                                                (ref1 = tierDesc.descriptions) === null || ref1 === void 0 ? void 0 : ref1.join(" & ")
                                            ]
                                        }, index)
                                    }) : null;
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            justify: !isApplicableWithCombo || !!allItemHightLightDescriptions.length ? "space-between" : "end",
                            align: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: [
                                        !isApplicableWithCombo && (0,i18n.t)("Kh\xf4ng \xe1p dụng c\xf9ng combo"),
                                        !!allItemHightLightDescriptions.length && allItemHightLightDescriptions[0], 
                                    ].filter(Boolean).map((message, index)=>{
                                        const color = epicOmni1643 ? "warning" : "#00973C";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                            align: "middle",
                                            justify: "start",
                                            children: [
                                                !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InforOutlined_es/* InforOutlined */.l, {
                                                    size: 16,
                                                    color: color
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                    color: color,
                                                    marginLeft: "s4",
                                                    children: message
                                                })
                                            ]
                                        }, index);
                                    })
                                }),
                                !isCustomerTierPromotions && !epicOmni1643 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDetailButton, {
                                        onClick: ()=>setShowDetail(true),
                                        children: (0,i18n.t)("Xem chi tiết")
                                    })
                                })
                            ]
                        }),
                        epicOmni1643 && !isCustomerTierPromotions && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChevron_es/* ButtonChevron */.y, {
                                direction: "down",
                                style: {
                                    border: "none"
                                },
                                onClick: ()=>setShowDetail(true),
                                children: (0,i18n.t)("Xem th\xeam")
                            })
                        })
                    ]
                })
            }) : null,
            !!showDetail && (!!isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomSheet, {
                show: showDetail,
                title: (0,i18n.t)("Chi tiết khuyến m\xe3i"),
                closeBottomSheet: handleCloseDetailModal,
                backdropClicked: handleCloseDetailModal,
                contentHeight: "500px",
                zIndex: 1060,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    padding: [
                        "s4",
                        "s16"
                    ],
                    children: renderDetailContent()
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
                width: 600,
                visible: showDetail,
                title: (0,i18n.t)("Chi tiết khuyến m\xe3i"),
                centeredTitle: true,
                okText: "",
                cancelText: (0,i18n.t)("Đ\xf3ng"),
                onCancel: handleCloseDetailModal,
                onClose: handleCloseDetailModal,
                showCloseIcon: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBody, {
                    children: renderDetailContent()
                })
            }))
        ]
    });
};
/* ---------------- Styled ---------------- */ const PromotionBox = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)((param)=>{
    let { epicOmni1643 , theme  } = param;
    return "\n  position: relative;\n  background: \n    ".concat(!epicOmni1643 ? "linear-gradient(180deg,rgba(0, 151, 60, 0.1) 0%,rgba(0, 151, 60, 0) 100%)" : theme.colors.secondary50, "}\n      ;\n");
});
const StyledLabel = emotion_styled_browser_esm["default"].div((param)=>{
    let { epicOmni1643 , theme  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: max-content;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  border-top-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  padding: 0.25rem 1rem 0.25rem 1rem;\n  background: ".concat(!epicOmni1643 ? "linear-gradient(90deg, #fae14c 59.21%, #00973c 100%)" : theme.colors.primary, ";\n");
});
const StyledDetailButton = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)(_templateObject());
const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)(_templateObject1());
const StyledModalBody = (0,emotion_styled_browser_esm["default"])(ModalBody_es/* ModalBody */.f)(_templateObject2());
const TierDescList = emotion_styled_browser_esm["default"].ul((param)=>{
    let { marginBottom  } = param;
    return "\n  list-style-position: inside;\n  margin-bottom: ".concat(marginBottom, ";\n");
});
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)(_templateObject3());
const StyledUl = emotion_styled_browser_esm["default"].ul(_templateObject4());


/***/ }),

/***/ 77322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ trackViewProductDetail; },
/* harmony export */   "u": function() { return /* binding */ trackViewProductList; }
/* harmony export */ });
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(437618);


const trackViewProductDetail = (product) => {
  var _a, _b;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackMetaPixelViewContent */ .SI)({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};




/***/ })

}]);